<template>
  <div
    class="screen-instagram vs-con-loading__container"
    ref="screen"
    :style="`width: ${screenWidth}px; height: ${screenHeight}px; background-color: ${isVideo && video ? 'black' : imageAverageColor}; overflow: ${isReel ? 'visible': 'hidden'}`"
    @mouseup="moveTextEnd"
    @mousemove="moveText"
    @mousedown="(e) => deselectDragObjects(null)"
    v-click-outside="deselectDragObjects"
  >
    <div class="centered-line-vertical" v-if="centerWidget"></div>
    <audio @canplaythrough="(e) => e.target.volume = '0.5'" ref="music-story-maker" v-if="music" :src="onlyViewMode ? '' : music.track.fast_start_progressive_download_url"></audio>
    <!-- <div v-if="music && music.config" class="music-back-dark"></div> -->
    <div v-if="music && music.config" class="music-config">
      <select @focus="pauseMusic" @change="e => setDurationMusic(e.target.value)" v-if="!video" class="timer-music">
        <option :selected="k === music.duration/1000" :key="k" v-for="k of [5,6,7,8,9,10,11,12,13,14,15]" :value="k">{{k}}</option>
      </select>
      <select disabled v-else class="timer-music">
        <option  :value="music.duration/1000">{{Math.round(music.duration/1000)}}</option>
      </select>
      <vue-slider class="slider" dotSize="10" v-model="musicConfigRange" :fixed="true" :min="0" :max="music.track.duration_in_ms"
      :tooltip-formatter="(ms) => `${Math.floor(ms / 60000)}:${String(Math.round((ms % 60000) / 1000)).padStart(2, '0')}`"
      :marks="music.track.highlight_start_times_in_ms" :hide-label="true" @drag-end="() => setMusicTimer()" @drag-start="() => pauseMusic()" @change="() => setMusicTimer()"
      :dotStyle="{visibility: 'hidden', width: '50px'}" :processStyle="{backgroundColor: 'white', zIndex: 1000}" :railStyle="{backgroundColor: 'rgb(94,86,83)'}"/>
      <vs-icon class="control" v-if="this.$refs['music-story-maker'] && !this.$refs['music-story-maker'].paused" @click="pauseMusic()" icon="stop_circle"></vs-icon>
      <vs-icon class="control" v-else @click="playMusic()" icon="play_arrow"></vs-icon>
      <div class="music-position-container"><div :style="{left: positionMusicBar}" class="music-position"></div></div>
      <div class="music-progress">
        <div :style="{width: percentMusicPlaying}" class="music-percent"></div>
      </div>
    </div>
    <div v-else-if="music && !textMode" class="music-preview" :style="(isReel && `bottom: 15px; left: 10px; top: unset;`) || (onlyViewMode && `top: 30px; left: 5px; scale: 0.7;`)">
      <img src="https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif">
      <p><b>{{musicPreview[0]}}</b> . {{musicPreview[1]}} ›</p>
    </div>
    

    <div class="page-name " v-if="onlyViewMode && pageInfo" slot="header">
      <vs-avatar class="page-img"
        color="transparent"
        size="28px"
        :src="pageInfo.avatar"
      />
      <p>{{ pageInfo.name }}</p>
      <span class="page-time">10s</span>
    </div>
    <div @click="confirmText" class="no-image" v-if="!video && !image && !autoImage"></div>
    <vs-button radius text-color="white" color="transparent" type="border"
      class="add-image"
      @click="addImage"
      v-if="!video && !image && !autoImage && !onlyViewMode && !textMode && !(dragText || linkMoving || pollMoving || sliderMoving || mentionsWidgetMoving) && !highlightPopup"
      icon="photo_camera"
    >
    </vs-button>
    <div v-if="!video && !image && autoImage" class="background-img"></div>
    <!-- <div v-else-if="isVideo && video && typeof video === 'string'" class="background-video"></div> -->

    <div class="background-img" :style="`position: relative; background: linear-gradient(${gradientSharedImageColor[0]}, ${gradientSharedImageColor[1]})`" v-if="isShare">
      <div v-if="isVisualShare" :style="`left: ${screenWidth/2}px; top: ${screenHeight/2}px; height: ${shareImageHeight + 90}px;`" class="share-visual"></div>
      <img v-if="isVisualShare" :style="`top: ${screenHeight/2 - shareImageHeight/2 - 23}px;`" class="share-visual-avatar" :src="picProfil" alt="">
      <p v-if="isVisualShare" class="share-visual-username"  :style="`top: ${screenHeight/2 - shareImageHeight/2 - 28}px;`">{{usernameShared}}</p>
      <p v-if="isVisualShare" :style="`top: ${screenHeight/2 + shareImageHeight/2 + 6}px;`" class="share-visual-text"><span>{{usernameShared}}</span>  {{isVisualShare}}</p>
      <img @click="$emit('toggleVisual')" class="share-img" :style="`left: ${screenWidth/2}px; top: ${screenHeight/2}px;`" :src="image" alt="" @load="shareLoadImage">
      <p v-if="!isVisualShare" class="share-user" :style="`top: ${screenHeight/2 + shareImageHeight/2 + 6}px;`">@{{usernameShared}}</p>
    </div>
    <video :style="`${linkMoving && 'pointer-events: none;'}`" @canplaythrough="(e) => music && (e.target.volume = '0.5')" crossorigin="anonymous" ref="video-story-maker" v-else-if="isVideo && video && typeof video === 'string'" :src="video + '?no-cache'" draggable="false" class="background-img" controls
     @play="playMusic" @pause="pauseMusic" @seeked="setMusicSeek" @volumechange="muteVideoIfMusic" :poster="(isReel && (injectedImage || (post.page && post.page[0] && post.page[0].enclosure) || post.enclosure)) ? (injectedImage || post.enclosure || post.page[0].enclosure) : null"/>
    <img @click="confirmText"
      draggable="false"
      @dragstart.prevent
      v-else-if="image"
      :src="image"
      alt="Image"
      class="background-img"
      id="main-img"
      ref="main-img"
      :style="`background-color: ${imageAverageColor};`"
    />
    <img v-if="template && template !== 'custom'" class="template-img" :src="`https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/${template}.png`" 
    alt="" :style="`width: ${screenWidth}px; height: ${screenHeight}px`">
    <img v-for="layer of layers" :key="layer.url" :src="layer.url" alt="" :style="{width: `${layer.w/(1080/screenWidth)}px`, height: `${layer.h/(1080/screenWidth)}px`, left: `${layer.x/(1080/screenWidth)}px`, top: `${layer.y/(1080/screenWidth)}px`, position: 'absolute'}">
    
    <div class="gifs-container" v-if="!cropMode && !isShare && !isVideo && manualLayers && !onlyViewMode">
      <img :class="`image-layer image-layer-${onlyViewMode}`" :style="`max-width: ${screenWidth}px;`" :id="`layer-${i}-${onlyViewMode}`" @mousedown="(e) => setLayerSelected(e, i)" v-for="(layer, i) in manualLayers" :key="i.toString() + onlyViewMode" :src="layer.reader || layer.url" :alt="i">
    </div>
    <div class="gifs-container" v-if="!cropMode && !isShare && !isVideo && manualLayers && onlyViewMode" >
      <img :class="`image-layer image-layer-${onlyViewMode}`" :style="`left: ${layer.x}; top: ${layer.y}; width: ${layer.w}; max-width: ${screenWidth}px`" :id="`layer-${i}-${onlyViewMode}`" v-for="(layer, i) in manualLayers" :key="i.toString() + onlyViewMode" :src="layer.reader || layer.url" :alt="i">
    </div>

    <div class="gifs-container" v-if="!cropMode && !isShare && gifs && !onlyViewMode" >
      <img :class="`image-gifs image-gif-${onlyViewMode}`" @mousedown="(e) => setGifBorder(e, gif.id)" :style="`max-width: ${screenWidth}px; border: ${gif.id === gifSelected ? '2px solid rgb(222, 6, 136)' : 'none' }`" :id="`gif-${i}-${onlyViewMode}`" v-for="(gif, i) in gifs" :key="gif.id + onlyViewMode" :src="gif.images.preview_gif.url" :alt="gif.name">
    </div>
    <div class="gifs-container" v-if="!cropMode && !isShare && gifs && onlyViewMode" >
      <img :class="`image-gifs image-gif-${onlyViewMode}`" :style="`left: ${gif.x}; top: ${gif.y}; width: ${gif.w}; max-width: ${screenWidth}px; border: ${gif.id === gifSelected ? '2px solid rgb(222, 6, 136)' : 'none' }`" :id="`gif-${i}-${onlyViewMode}`" v-for="(gif, i) in gifs" :key="gif.id + onlyViewMode" :src="gif.images.preview_gif.url" :alt="gif.name">
    </div>

    <div @click="() => changeMentionWidgetColor(i)" @mousedown="(e) => setMentionSelected(e, mention.pk)" :class="`mentions-widget mention-widget-${onlyViewMode} style-mention${mention.color} ${mention.hide ? 'hidden-mention' : ''}`" :id="`mention-widget-${i}-${onlyViewMode}`" v-for="(mention, i) in mentionsWidget" :key="mention.pk">
      <span v-if="mention.color === 3" class="mention-widget-text"><span class="arobase">@</span>{{mention.id}}</span>
      <span v-else class="mention-widget-text">@{{mention.id}}</span>
    </div>

    <div v-if="isReel && !(music && music.config)" class="reel-cta">
        <div><svg aria-label="J’aime" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path d="M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z"></path></svg></div>
        <div><svg aria-label="Commenter" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path clip-rule="evenodd" d="M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z" fill-rule="evenodd"></path></svg></div>  
        <div><svg aria-label="Partager la publication" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path d="M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z"></path></svg></div>
        <div>. . .</div>
    </div>
    <div v-if="!textMode && !cropMode && !onlyViewMode" class="icons-bar" data-html2canvas-ignore>
      <div v-if="!isReel" @click="() => (confirmDelete = true)" class="remove-img icons-white icons"></div>
      <div v-else-if="isReel">
        <p class="reel-name">Reels</p>
      </div>
      <img
        v-if="image && !isVideo && !isShare"
        @click="cropImage"
        class="crop-img icons-white"
        src="../../assets/img/icon_instagram_pencil.svg"
        alt="Crop"
      />
      <!-- <img
        v-if="image"
        @click="addLink"
        class="stickers-img icons-white"
        src="../../assets/img/icon_instagram_stickers.webp"
        alt="Stickers"
      /> -->
      <div v-if="!isShare" @click="addText" no-deselect class="add-text-icon icons icons-white"></div>
    </div>
    <div v-if="confirmDelete" class="popup-disable-background icons-white" data-html2canvas-ignore></div>
    <div class="popup-remove-img" v-if="confirmDelete">
      <div class="txt-container-remove-img">
        <h3 class="title-remove-img">Abandonner la photo ?</h3>
        <div class="txt-remove-img">
          Si vous revenez en arrière maintenant, vous perdrez votre template
        </div>
      </div>
      <div class="btn-remove-img">
        <button
          @click="() => (confirmDelete = false)"
          class="cancel-remove-img"
          tabindex="0"
        >
          Conserver
        </button>
        <button @click="resetStory" class="confirm-remove-img" tabindex="0">
          Abandonner
        </button>
      </div>
    </div>
    <div class="justify icons-white" v-if="textMode" data-html2canvas-ignore>
      <img v-if="justify === 'center'" src="../../assets/img/icon_instagram_justify_center.png" alt="center" @click="justifyText">
      <img v-if="justify === 'left'" src="../../assets/img/icon_instagram_justify_left.png" alt="left" @click="justifyText">
      <img class="reverse" v-if="justify === 'right'" src="../../assets/img/icon_instagram_justify_left.png" alt="right" @click="justifyText">
    </div>
    <img v-if="textMode" @click="[colorSwitch = !colorSwitch, nextTickSetEndOfContenteditable()]" src="../../assets/img/icon_instagram_color.png" alt="" class="color-switch " data-html2canvas-ignore>
    <img v-if="textMode" @click="[text[currentTextIndex].background = (text[currentTextIndex].background + 1)%(text[currentTextIndex].font === 3 ? 2 : 3), nextTickSetEndOfContenteditable()]" :src="require(`../../assets/img/icon_instagram_fond${text[currentTextIndex].background === 0 ? 1 : 2}.png`)" alt="FOND" class="fond-text icons-white" data-html2canvas-ignore>
    <vs-button
      @click="confirmText"
      class="confirm-text"
      v-if="textMode"
      type="flat" data-html2canvas-ignore
      ><span class="icons-white txt-btn">Terminer</span></vs-button
    >
    <vs-button
      @click="cancelCrop"
      class="cancel-crop confirm-text icons-white"
      v-if="cropMode"
      type="flat" data-html2canvas-ignore
      ><span class="icons-white txt-btn">Annuler</span></vs-button
    >
    <vs-button
      @click="confirmCrop"
      class="confirm-text icons-white"
      v-if="cropMode"
      type="flat" data-html2canvas-ignore
      ><span class="icons-white txt-btn">Sauvegarder</span></vs-button
    >
    <!-- <div ref="text" @click="modifyText" v-if="text" :contenteditable="textMode" class="text" 
        :style="`color: ${text.color}; font-size: ${text.size}px; left:${text.x}; top:${text.y};`">
        {{ text.content }}
      </div> -->
    <img v-if="textMode" class="slider-size icons-white loupe-plus" src="../../assets/img/icon_instagram_txt_plus.png" alt="+" data-html2canvas-ignore>

    <vue-slider
      v-model="text[currentTextIndex].size"
      v-if="textMode"
      class="slider-size"
      :height="350"
      direction="btt"
      :min="15"
      :max="75"
      :width="7"
      :tooltip="'active'"
      :tooltip-placement="'right'"
      :dotSize="17"
      :process-style="{ backgroundColor: '#B20565' }"
      :dot-style="{ backgroundColor: '#B20565', borderColor: '#F8F8F8' }"
      :rail-style="{ backgroundColor: 'white' }"
      @drag-end="changeSize"
      data-html2canvas-ignore
    />
    <img v-if="textMode" class="icons-white slider-size loupe-moins" src="../../assets/img/icon_instagram_txt_moins.png" alt="-" data-html2canvas-ignore>


    <img v-if="cropMode" class="slider-size icons-white loupe-plus" src="../../assets/img/icon_instagram_loupe_plus.svg" alt="+" data-html2canvas-ignore>
    <vue-slider
      v-model="cropZoom"
      v-if="cropMode"
      class="slider-size"
      :height="350"
      direction="btt"
      :min="0.01"
      :max="3"
      :interval="0.01"
      :width="5"
      :tooltip="'hover'"
      :tooltip-placement="'right'"
      :dotSize="15"
      :process-style="{ backgroundColor: '#B20565' }"
      :dot-style="{ backgroundColor: '#B20565', borderColor: '#F8F8F8' }"
      :rail-style="{ backgroundColor: 'white' }"
      @change="changeZoom"
      data-html2canvas-ignore
    />
    <img v-if="cropMode" class="slider-size icons-white loupe-moins" src="../../assets/img/icon_instagram_loupe_moins.svg" alt="-" data-html2canvas-ignore>
    
    <!-- {{text.length}} -->
    <span v-for="(txt, idx) in text" :key="idx">
      <img v-if="textMode && currentTextIndex === idx ? 'none' :''" class="rotation-btn" src="../../assets/img/icon_instagram_rotate_txt.svg" alt="rotate"
      data-html2canvas-ignore @dragstart.prevent @mousedown="e => rotateTextBegin(e, idx)"
      :style="`left:${rotatedPosition(idx).x}px; top:${rotatedPosition(idx).y}px; width:${txt.size/2}px;`">

      <!-- <div v-if="textMode" :style="`width: 3px; height: 3px; background-color: red; position: absolute; top: ${centerText(idx).y}px; left: ${centerText(idx).x}px`"></div> -->

      <p v-if="!isShare && txt.content && !cropMode && (!textMode || onlyViewMode ||  currentTextIndex !== idx)" :ref="`text${idx}`" :class="`text font${txt.font} ${txt.background !== 0 ? 'fond': ''}`" 
        @mousedown="e => moveTextBegin(e, idx)" @click="modifyText(idx)" no-deselect
        :style="`
        color: ${txt.background === 2 || preview ? (['white', '#FFF', '#FFFFFF'].includes(txt.color) ? 'black':  'white' ) : (txt.background === 1 && txt.font === 3) ? 'white' : txt.color}; 
        font-size: ${txt.size}px; 
        left:${txt.x - (template === 'custom' && textStatic ? 50 : 0)}px; 
        top:${txt.y - (template === 'custom' && textStatic ? 30 : 0)}px; 
        transform: rotate(${txt.angle}deg) ${textCenter ? 'translate(-50%, -50%)': ''};
        ${txt.background !== 0 ? ('padding-top:' + (txt.font === 3 ? '0;': txt.font === 2 ? '16px;' : '7px;')) : ('padding-top:' + (txt.font === 3 ? '-10px;': txt.font === 2 ? '12px;' : '3px;'))} width: ${preview ? '80%' : ''}`">
        
        <span no-deselect :class="`background-txt-custom-${txt.font} font${txt.font}`" :style="`display: inline-block; white-space: pre-line; background-color: ${txt.background === 2 ? txt.color : txt.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(txt.color) ? 'black':  'white' ) : 'transparent'};
          text-shadow: ${txt.background === 1 && txt.font === 3 ? '1px 1px 2px black, 0 0 10px ' + (txt.color.includes('#') ? txt.color : ['black', '#000', '#000000'].includes(txt.color) ? '#000000' : '#FFFFFF') + ', 0 0 1px' + (txt.color.includes('#') ? txt.color : ['black', '#000', '#000000'].includes(txt.color) ? '#000000' : '#FFFFFF') + ';' : 'none'};`"
        >{{textPreview[idx]}}</span>
      </p>
      
      <div v-else-if="!isShare && txt !== null && !cropMode && currentTextIndex === idx"  :class="`text font${txt.font} ${txt.background !== 0 ? 'fond': ''}`"
      :style="`color: ${txt.background === 2 ? (['white', '#FFF', '#FFFFFF'].includes(txt.color) ? 'black':  'white' ) : (txt.background === 1 && txt.font === 3) ? 'white' : txt.color}; font-size: ${txt.size}px; left:${txt.x}px; top:${txt.y}px; border:${!textMode && !dragText && txt.background === 0 ? 'none':  currentTextIndex !== idx ? 'none' :''}; ${txt.background !== 0 ? ('padding-top:' + (txt.font === 3 ? '0;': txt.font === 2 ? '16px;' : '7px;')) : ('padding-top:' + (txt.font === 3 ? '-10px;': txt.font === 2 ? '12px;' : '3px;'))}
           border: ${txt.background === 0  && txt.content.trim() !== '' ? 'rgba(255, 255, 255, 0.3) solid 1px' : 'none'};
           transform: rotate(${txt.angle}deg); `">

        <contenteditable :ref="`text${idx}`"
          @click="modifyText(idx)"
          @mousedown="e => moveTextBegin(e, idx)"
          :class="`background-txt-custom-${txt.font} font${txt.font}`"
          tag="span"
          :contenteditable="textMode && !onlyViewMode"
          v-model="txt.content"
          :noNL="false"
          :noHTML="true"
          :style="`display: inline-block; background:${!textMode && !dragText && txt.background === 0 ? 'none':  (currentTextIndex !== idx && txt.background === 0) ? 'none' :''}; 
          background-color: ${txt.background === 2 ? txt.color : txt.background === 1 ? (['white', '#FFF', '#FFFFFF'].includes(txt.color) ? 'black':  'white' ) : 'transparent'};
          color: ${txt.background === 2 ? (['white', '#FFF', '#FFFFFF'].includes(txt.color) ? 'black':  'white' ) : (txt.background === 1 && txt.font === 3) ? 'white' : txt.color};
          text-shadow: ${txt.background === 1 && txt.font === 3 ? '1px 1px 2px black, 0 0 10px ' + (txt.color.includes('#') ? txt.color : (['black', '#000', '#000000'].includes(txt.color) ? '#000000' : '#FFFFFF')) + ', 0 0 1px' + (txt.color.includes('#') ? txt.color : (['black', '#000', '#000000'].includes(txt.color) ? '#000000' : '#FFFFFF')) + ';' : 'none'};`"
        />
      </div>
    </span>
    <div v-if="textMode && colorSwitch" class="colors-text" data-html2canvas-ignore>
      <div
        v-for="color in colors"
        :key="color"
        class="color"
        :style="`background-color: ${color}; border-color: ${color === 'white' ? 'black': 'white'}`"
        @click="changeColor(color)"
      ></div>
      <!-- <div class="color custom"></div> -->
      <!-- <input
        v-model="text[currentTextIndex].color"
        @change="changeSize"
        type="color"
        class="color"
      /> -->
    </div>
    <div v-if="(dragText || linkMoving || pollMoving || sliderMoving || mentionsWidgetMoving) && !highlightPopup" class="delete-text" data-html2canvas-ignore>
      <div class="circle" @mouseup="deleteWidget"></div>
      <img
        :src="require('../../assets/img/icon_instagram_trash.svg')"
        alt="Delete"
        class="delete-img"
      />
    </div>
    <div v-if="!textMode && !dragText && cropMode" class="img-transform" data-html2canvas-ignore>
      <img @click="() => cropper.rotate(45)" class="icon-rotate icons-white txt-btn" src="../../assets/img/icon_instagram_rotate.svg" alt="rotate +">
      <img @click="() => cropper.rotate(-45)" class="icon-rotate icons-white txt-btn" src="../../assets/img/icon_instagram_rotate_neg.svg" alt="rotate -">
      <img @click="() => cropper.scaleX(cropper.getImageData().scaleX * -1)" class="icon-rotate icons-white txt-btn" src="../../assets/img/icon_instagram_inverse_x.svg" alt="inverse x">
      <img @click="() => cropper.scaleY(cropper.getImageData().scaleY * -1)" class="icon-rotate icons-white txt-btn" src="../../assets/img/icon_instagram_inverse_y.svg" alt="inverse y">
    </div>

    <div v-if="textMode && !dragText && !highlightPopup" class="fonts-text" data-html2canvas-ignore>
      <span v-for="k in 4" :key="k" :class="`font${k} font`" :style="`background-color: ${k === text[currentTextIndex].font ? 'white;':'#26262670;'} color: ${k === text[currentTextIndex].font ? '#ba3420' : 'white'}`" @click="textFont(k)">Aa</span>
    </div>

    <div v-if="highlightPopup && !onlyViewMode && enableHighlight" @click="selectHighlight" class="close-highlight"></div>
    <p class="p-highlight" v-if="highlightPopup && !onlyViewMode && enableHighlight">Ajouter aux éléments à la une</p>
    <div v-if="highlightPopup && !onlyViewMode && enableHighlight" class="highlights vs-con-loading__container" data-html2canvas-ignore ref="loadingHighlight">  
      <label class="highlight">
        <vs-radio class="hidden" v-model="currentHighlight" :vs-value="null"></vs-radio>
        <div class="highlight-img" :style="currentHighlight === null && 'border: solid 2.5px white'">
          X
        </div>
        Aucun
      </label>
      <label v-for="h of highlightsPage" class="highlight" :key="h.title">
        <vs-radio class="hidden" @change="selectHighlight" v-model="currentHighlight" :vs-value="h.title"></vs-radio>
        <img :src="h.img" alt="" class="highlight-img" :style="currentHighlight === h.title && 'border: solid 2.5px white'">
        {{h.title}}
      </label>
      <label class="highlight">
        <vs-radio class="hidden" v-model="currentHighlight" vs-value="__new_highlight__"></vs-radio>
        <div class="highlight-img" :style="currentHighlight === '__new_highlight__' && 'border: solid 2.5px white'">
          +
        </div>
        <vs-input v-model="newHighlight" class="new-highlight" size="small" :style="currentHighlight === '__new_highlight__' && 'border: solid 1px white'" :danger="!isValidHightlight" danger-text="Invalide"></vs-input>
      </label>
    </div>
    <img v-else-if="enableHighlight && !cropMode && !textMode && !onlyViewMode && !isReel" class="highlight-icon icons-white" @click="openHighlight" :src="currentHighlightThumbnail" alt="" data-html2canvas-ignore>

    <!-- <div v-if="image && !textMode && !cropMode && link && !highlightPopup" class="swipe-up">
      <img class="swipe-img" src="../../assets/img/icon_instagram_swipe_up.svg" alt="SwipeUp">
      <div class="swipe-txt">See More</div>
    </div> -->
    <!-- <div v-if="!textMode && !dragText" class="submit-story" @click="submitTemplate">
        <div class="icon-submit"></div>
        <p class="text-submit">Confirmer la template</p>
      </div> -->
      <!-- draggable-link  a remettre en class sur la div du dessous -->
    <div ref="link" id="link-container" v-if="link && !cropMode && !onlyViewMode" @click="changeLinkColor" :class="`link-container style-link${linkColor} ${!onlyViewMode && 'draggable-link'}`" :style="{left: leftLinkPos, cursor: onlyViewMode && 'pointer'}"> 
      <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
      <p class="link-txt">{{linkText ? linkText.toUpperCase() : link.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
      <div class="corner edge-top edge-left"></div>
      <div class="corner edge-top edge-right"></div>
      <div class="corner edge-bottom edge-right"></div>
      <div class="corner edge-bottom edge-left"></div>
      <!-- <img data-html2canvas-ignore class="link-rotate" id="link-rotate" src="../../assets/img/icon_instagram_rotate_txt.svg" alt="⤵"> -->
    </div>

    <div ref="link" id="link-container" v-if="link && !cropMode && onlyViewMode && posiLink" @click="linkAction" :class="`link-container-view style-link${linkColor}`" :style="{transform: `translate(${posiLink.x}px,${posiLink.y}px) translateX(-50%) rotate(${(posiLink.angle || 0)}rad) scale(${(posiLink.scale || 1)})`, top: `-15px`, cursor: onlyViewMode && 'pointer'}"> 
      <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
      <p class="link-txt">{{linkText ? linkText.toUpperCase() : link.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
    </div>

    <!-- <div v-if="!isShare && poll && !onlyViewMode && !isVideo" ref="poll" :class="`poll-container ${!onlyViewMode && 'draggable-poll'}`" id="poll-container">
      <p class="poll-question">{{poll.question || "Question ?"}}</p>
      <div class="poll-choices">
        <span class="blue"><span class="text-choice" id="poll-option-1">{{poll.options[0] || "OUI"}}</span></span>
        <span class="pink"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "NON"}}</span></span>
        <span class="pink"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "NON"}}</span></span>
        <span class="pink"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "NON"}}</span></span>
      </div>
    </div> -->

      <div v-if="!isShare && poll && !onlyViewMode" ref="poll" :class="`poll-container-v2 ${!onlyViewMode && 'draggable-poll'}`" id="poll-container">
        <div v-if="poll.question.length > 0" class="poll-question">
          <p class="">{{poll.question || "Question ?"}}</p>
        </div>
        <div class="poll-choices">
          <span class="choice-container"><span class="text-choice" id="poll-option-1">{{poll.options[0] || "Oui"}}</span></span>
          <span class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "Non"}}</span></span>
          <span v-if="poll.options[2]" class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[2]}}</span></span>
          <span v-if="poll.options[3]" class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[3]}}</span></span>
        </div>
      </div>

      <div v-else-if="!isShare && poll && onlyViewMode" ref="poll" :class="`poll-container-v2`" :style="{left: poll.x+'px', top: poll.y+'px'}" id="poll-container">
        <div v-if="poll.question.length > 0" class="poll-question">
          <p class="">{{poll.question || "Question ?"}}</p>
        </div>
        <div class="poll-choices">
          <span class="choice-container"><span class="text-choice" id="poll-option-1">{{poll.options[0] || "Oui"}}</span></span>
          <span class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[1] || "Non"}}</span></span>
          <span v-if="poll.options[2]" class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[2]}}</span></span>
          <span v-if="poll.options[3]" class="choice-container"><span class="text-choice" id="poll-option-2">{{poll.options[3]}}</span></span>
        </div>
      </div>

      <div @click="changeSliderColor" v-if="!isShare && slider && !onlyViewMode" ref="slider" :class="`slider-container ${!onlyViewMode && 'draggable-slider'}`" :style="{backgroundColor: sliderColorPossibles[sliderColor]}" id="slider-container">
        <p v-if="slider.question" :style="{color: (sliderColor === 0 ? '#000000' : '#ffffff')}" class="slider-question">{{slider.question || "Question ?"}}</p>
        <div class="slider-slide">
          <span class="emoji">{{slider.emoji}}</span>
          <div class="bar"></div>
        </div>
      </div>

      <div v-if="!isShare && slider && onlyViewMode" ref="slider" :class="`slider-container`" :style="{backgroundColor: sliderColorPossibles[sliderColor], left: slider.x+'px', top: slider.y+'px'}" id="slider-container">
        <p v-if="slider.question" :style="{color: (sliderColor === 0 ? '#000000' : '#ffffff')}" class="slider-question">{{slider.question || "Question ?"}}</p>
        <div class="slider-slide">
          <span class="emoji">{{slider.emoji}}</span>
          <div class="bar"></div>
        </div>
      </div>

      <div class="reel-modifier" v-if="isReel && !(music && music.config)">
        <div class="reel-background"></div>
        <a class="reel-avatar" :href="`https://www.instagram.com/${pageInfo.name}`" target="blank">
          <page-image-avatar :page="pageInfo"/>
          <p class="page-name">{{`${pageInfo.name}`}}</p><p class="reel-follow">Suivre</p>
        </a>
        <div v-if="reelText" class="title reel-title" :class="[{'lorem' : reelText == '', live: true }]">
          <div class="title-cont" v-if="!activeEdit.title" @click.prevent="!activeEdit.title ? showEditPost('title') : null">
            <span class="hashtag-prefix" v-if="activePrefixSuffix && bot && bot.hashtagPrefix && reelText != ''"
              v-html="`${addHashtagsLinks(bot.hashtagPrefix)} `"
            ></span>
            <span v-html="(getMessageToPost(post).slice(0, 80))"></span>{{getMessageToPost(post).length > 80 ? '...' : ''}}
            <span class="hashtag-suffix" v-if="activePrefixSuffix && bot && bot.hashtag && reelText != ''"
              v-html="` ${addHashtagsLinks(bot.hashtag)}`"
            ></span>
          </div>
          <div v-if="reelText != ''" class="live-title">
            <span class="btn-edit">
              <Tooltip
                :text="$t('dash.post.overlay.edit.message')"
                position="top"
              >
                <vs-button
                  v-show="!activeEdit.title"
                  vs-type="filled"
                  @click.prevent="showEditPost('title')"
                  icon="edit"
                  class="button-reel"
                  style="background: none !important;"
                ></vs-button>
                &nbsp;&nbsp;
              </Tooltip>
            </span>
            <div class="edit-title" v-if="activeEdit.title">
              <vs-button
                vs-type="filled"
                @click.prevent="activeEdit.title = false"
                icon="close"
                class="close button-reel"
                style="background: none !important;"
              ></vs-button>
              <vs-button
                vs-type="filled"
                @click.prevent="editPost('title')"
                icon="check"
                class="save button-reel"
                style="background: none !important;"
              ></vs-button>
              
              <div class="textarea-emoji-picker">
                <div class="styles-text-buttons">
                  <span @click="styleSelection('bold')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('bold') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                    </svg>
                  </span>
                  <span @click="styleSelection('italic')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('italic') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                    </svg>
                  </span>
                  <span @click="styleSelection('underline')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('underline') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                      <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                    </svg>
                  </span>
                </div>
                <picker
                  :data="emojiIndex"
                  v-show="showEmojiPicker"
                  title="Pick your emoji..."
                  emoji="point_up"
                  @select="addEmoji"
                />
                <span
                  class="emoji-trigger"
                  :class="{ 'triggered': showEmojiPicker }"
                  @click="toggleEmojiPicker"
                >
                  <svg
                    style="width:20px;height:20px"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                  </svg>
                </span>
                <span class="add-mention" @click="toggleShowMentions('Mention')">@</span>
                <span class="add-mention add-hashtag" @click="toggleShowMentions('Hashtag')">#</span>
                <span class="add-mention ai-generate" @click="getAccrochesByAI()"><span class="material-icons">lightbulb_outline</span></span>
                <vs-textarea 
                  :class="{'input': true}"
                  vs-size="large"
                  color="#B20564"
                  name="title"
                  :placeholder="$t('dash.posts.overlay.description_placeholder')"
                  v-model="editValue.title"
                  :ref="`inputTitle-${pageInfo.network_id}`"
                  :id="`inputTitle-${pageInfo.network_id}`"
                /> 
                <div class="vs-textarea--count" v-if="limitText()">
                  {{ sizeCurrentMessage() }} / {{ limitText() }}
                </div>  
              </div>
            </div>
          </div>
        </div>
        <!-- <Tooltip :style="{top : '-170px' }" position="top" :text="userTagsReel ? userTagsReel.list.map(e=>e.username).join(', ') : post.userTagsReel.list.map(e=>e.username).join(', ')" v-if="(userTagsReel || post.userTagsReel) && (video)" class="tags">
          <i class="material-icons">person</i>
          &nbsp;
        </Tooltip>
        <Tooltip :style="{top : '-170px' }" v-else-if="post.page && post.page[0] && post.page[0].userTagsReel" :text="JSON.parse(post.page[0].userTagsReel).list.map(e=>e.username).join(', ')" class="tags">
          <i class="material-icons">person</i>
          &nbsp;
        </Tooltip> -->
      </div>
      

     <!-- <div v-else-if="!isShare && poll && onlyViewMode && !isVideo" ref="poll" :class="`poll-container`" :style="{left: poll.x+'px', top: poll.y+'px', width: 'inherit'}" id="poll-container">
      <p class="poll-question">{{poll.question || "Question ?"}}</p>
      <div class="poll-choices">
        <span class="blue"><span ref="poll-option-1" class="text-choice" id="poll-option-1">{{poll.options[0] || "OUI"}}</span></span>
        <span class="pink"><span ref="poll-option-2" class="text-choice" id="poll-option-2">{{poll.options[1] || "NON"}}</span></span>
      </div>
    </div> -->

    <input type="file" id="input-image" @change="chooseImage" hidden />
    
    
    
  </div>
  
</template>

<script>
import moment from 'moment'
import Fonts from '../../utils/Fonts'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import Posts from './../mixins/Posts'
import Bots from './../mixins/Bots'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
// import html2canvas from 'html2canvas-fitcontain';
import FastAverageColor from 'fast-average-color';
import interact from "interactjs";
import ColorThief from 'color-thief-browser'
import Notif from './../mixins/Notif'
import Tooltip from './tooltip/tooltipInit.vue'
import PageImageAvatar from './PageImageAvatar.vue'
import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'componentStoryMaker',
  components: {
    VueSlider,
    Tooltip,
    PageImageAvatar,
    Picker,

  },
  directives: {
    ClickOutside
  },
  mixins: [Posts, Bots, Notif],
  props: {
    linkText: String,
    pageInfo: Object,
    screenWidth: Number,
    screenHeight: Number,
    injectedText: Array,
    injectedImage: String,
    injectedLink: String,
    injectedBackground: Array,
    autoImage: { type: Boolean, default: false },
    onlyViewMode: { type: Boolean, default: false },
    mentions: Object,
    acceptPrefix: {type: Boolean, default: true},
    acceptReplaceHashtag: {type: Boolean, default: true},
    autoCrop: {type: Boolean, default: false},
    textCenter: {type: Boolean, default: false},
    enableHighlight: {type: Boolean, default: true},
    preview: {type: Boolean, default: false},
    template: {type: String, default: null},
    validMentions: {type: Array, default: () => []},
    validHashtags: {type: Array, default: () => []},
    templateConfig: {type: Object, default: null},
    posiLink: Object,
    manualLayers: {type: Array, default: () => []},
    draft: {type: Boolean, default: false},
    poll: Object,
    slider: Object,
    isVideo: Boolean,
    isShare: String | null,
    video: {type: String | File, default: null},
    isVisualShare: String | null,
    shareFacebook: Boolean,
    music: Object | null,
    gifs: {type: Array, default: () => []},
    isReel: Boolean,
    userTagsReel: Object | null,
    reelText: String | null,
    activePrefixSuffix: Boolean,
    post: Object,
    editPostValue: Array,
    mentionsWidget: {type: Array, default: () => []},
  },

  computed: {

    positionMusicBar() {
      // 103px - (-419px)
      if (!this.music) {
        return
      }
      let point = this.musicConfigRange[0];
      let max = this.music.track.duration_in_ms - (this.musicConfigRange[1]-point);
      let percent = 100 - ((point / max) * 100);
      let value = -419 + (percent / 100) * (105 - (-419));
      // console.log("PERCENT", percent, value);
      return `${value}px`;
    },

    musicPreview() {
      if (!this.music) return ['',''];
      let artist = this.music.track.display_artist;
      let title = this.music.track.title;
      let all = artist + title
      const maxlength = 30
      console.log(all.length, (all.length-maxlength)-title.length, (all.length-maxlength), title.length);
      if (all.length >= maxlength) {
        title = title.substring(0,  title.length - (all.length-maxlength)) + '...';
      }
      return [artist,title];
    },

    usernameShared() {
      if(this.shareUser) {
        return this.shareUser
      }
      return "Loading...";
    },

    currentHighlightThumbnail() {
      return this.currentHighlight && this.currentHighlight !== '__new_highlight__' ? this.highlightsPage.find(e => e.title === this.currentHighlight).img : require('../../assets/img/icon_instagram_highlight.png');
    },

    isValidHightlight() {
        let h = this.highlightsPage.map(e => e.title);
        return (this.currentHighlight === '__new_highlight__' && this.newHighlight !== '' && !h.includes(this.newHighlight)) || this.currentHighlight !== '__new_highlight__';
    },

    textPreview() {
      // console.log('mention', this.mentions);
      if (!this.mentions) return this.text.map(el => el.content);
      // console.log('ici', this.text);
      let previewsArray = [];
      for (let txt of this.text) {
        let preview = txt.content;
        // return this.text.content
        if (this.acceptReplaceHashtag && Array.isArray(this.mentions.hashtagsAuto)) {
          for (let tag of this.mentions.hashtagsAuto) {
            let regex = new RegExp("( |^)" + tag.correspondences.join('( |$)|( |^)') + "( |$)", 'g')
            preview = txt.content.replaceAll(regex, ' #'+tag.hashtag+' ').trim()
          }
        }
        if (this.acceptPrefix) {
          preview = this.mentions.hashtagPrefix + " " + preview + " " + this.mentions.hashtag;
        }
        const regexMention = /@\[MENTIONS-([0-9]*)\]/g;
        const matchMentions = preview.match(regexMention) || []
        console.log('match',matchMentions);
        for (let m of matchMentions) {
          console.log(m);
          preview = preview.replace(m, this.validMentions[parseInt(m.slice(-2)[0])-1][0].value);
        }
        const regexHashtag = /#\[HASHTAGS-([0-9]*)\]/g;
        const matchHashtag = preview.match(regexHashtag) || []
        console.log('match',matchHashtag);
        for (let m of matchHashtag) {
          console.log(m);
          preview = preview.replace(m, this.validHashtags[parseInt(m.slice(-2)[0])-1][0].value);
        }
        previewsArray.push(preview);
      }

      // console.log(previewsArray);
      return  previewsArray;
    },

  },

  mounted() {
    console.log('mounted',this.injectedText, this.injectedImage, this.templateConfig);
    console.log('template:',this.templateConfig);

    this.bot = this.post && this.post._bots && this.post._bots.page && this.post._bots.page.id == this.pageInfo.id ? this.post._bots : (localStorage.bots ? JSON.parse(localStorage.bots).find(b => b.page.id == this.pageInfo.id) : [])


    this.linkColor = this.posiLink.color;

    if (this.isShare) {
      this.getSharedUsername()
    }

    if (this.music) {
      if (this.isVideo && this.video) {
        let videoEl = this.$refs['video-story-maker'];
        videoEl.currentTime = 0;
        videoEl.muted = true;
        videoEl.loop = true;
        videoEl.play();
      } else {
        let audio = this.$refs['music-story-maker'];
        audio.play();
        this.musicPaused = false
      }
      this.musicConfigRange = [this.music.startTime, this.music.startTime + this.music.duration]
      this.setMusicTimer();
      if (this.isVideo && this.video && this.isReel) {
        let videoEl = this.$refs['video-story-maker'];
        videoEl.load();
        let audio = this.$refs['music-story-maker'];
        audio.load();
      }
      
    }
    


    if (this.posiLink && !this.onlyViewMode) {
      this.$nextTick(() => {
        console.log('posilink', this.posiLink);
        let linkEl = document.getElementById("link-container");
        if (linkEl) {
          this.moveLinkHandle({target: linkEl, dx: 0, dy: 0}, true);
          this.linkMoving = false;
          // linkEl.style.transform = 'rotate(' + (this.posiLink.angle || 0) + 'rad' + ') scale(' + (this.posiLink.scale || 1) + ')';
          // linkEl.style.transform = 'rotate('+(this.posiLink.angle || 0)+'rad)';
          // linkEl.style.left = `${this.posiLink.x}px`;
          // linkEl.style.top = `${this.posiLink.y}px`;
          // linkEl.style.scale = this.posiLink.scale || 1;
        }
      })
    }
    if (this.injectedText) {
      if (this.injectedText.length === 0) {
        this.text.push({
          x: this.screenWidth / 2 - 15,
          y: this.screenHeight / 2 - 50,
          content: '',
          color: 'white',
          // color: 'red',
          size: 22,
          font:  1,
          background:  0,
          angle:  0
        })
        this.oldWidthText.push(30);
        this.currentTextIndex = this.text.length - 1;
      }
      for (let txt of this.injectedText) {
        console.log(txt);
        this.text.push({
          x: (txt.x || txt.x === 0) ? txt.x : this.screenWidth / 2 - 10,
          // posx: (txt.x || txt.x === 0) ? txt.x : this.screenWidth / 2 - 10,
          y: (txt.y || txt.y === 0) ? txt.y : this.screenHeight / 2 - 10,
          content: txt.content,
          color: txt.color ? txt.color : 'white',
          size: txt.size ? txt.size : 22,
          font: txt.font ? txt.font : 1,
          background: txt.background ? txt.background : 0,
          angle: txt.angle ? txt.angle : 0,
          w: txt.w ? txt.w : undefined,
          h: txt.h ? txt.h : undefined,
          hide: txt.hide ? txt.hide : false,
        })
        // this.oldWidthText.push(30)
      }
      console.log(this.text[0].x);

      // setTimeout(() => this.textExpandSize(), 1000)
    }
    // console.log('injimg::',this.injectedImage);
    if (this.injectedImage) {
      console.log('IMMMG',this.injectedImage);
      const regUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/gm;
      if (regUrl.test(this.injectedImage)) {
        console.log('img url');
        this.$vs.loading({container: this.$refs.screen, color: '#43153D'})
        this.getImageFromUrl(this.injectedImage).then(result => {
          this.$vs.loading.close(this.$refs.screen);
          this.image = result.body.image;
          this.cropForFormat();
        });
      } else {
        this.image = this.injectedImage
        this.cropForFormat();  
      }
    }
    // console.log('img::',this.image);
    if (this.injectedLink) {
      this.link = this.injectedLink
      if (!this.image && !this.injectedImage && this.injectedLink !== '') {
        console.log('no img !!!', this.injectedImage, this.image);
        let meta = this.getMeta(this.injectedLink)
        // console.log('meta', meta)
      }
      if (!this.onlyViewMode) {
        this.$nextTick(() => {
          interact('#link-rotate').draggable({
            listeners: {
                start: (event) => {
                    this.linkMoving = true;
                    let box = document.getElementById("link-container");

                    let rect = box.getBoundingClientRect();
              
                    // store the center as the element has css `transform-origin: center center`
                    box.setAttribute('data-center-x', rect.left + rect.width / 2);
                    box.setAttribute('data-center-y', rect.top + rect.height / 2);
                    // get the angle of the element when the drag starts
                    box.setAttribute('data-angle', this.getDragAngle(event, box));
                  },
                // call this function on every dragmove event
                move: (e) => {
                  console.log(e,'rotatemove');
                    let box = document.getElementById("link-container");


                    let pos = {
                        x: parseFloat(box.getAttribute('data-x')) || 0,
                        y: parseFloat(box.getAttribute('data-y')) || 0
                    };
                    let scale = (parseFloat(box.getAttribute('data-scale')) || 1)

                    let angle = this.getDragAngle(e, box);

                    // update transform style on dragmove
                    box.style.transform = 'translate(' + pos.x + 'px, ' + pos.y + 'px) rotate(' + angle + 'rad' + ') scale(' + scale + ')';
                    
                },

                // call this function on every dragend event
                end: (event) => {
                    let box = document.getElementById("link-container");
                    // save the angle on dragend
                    let angle = this.getDragAngle(event, box);
                    box.setAttribute('data-angle', angle);
                    this.linkPosition.angle = angle;
                    console.log('link',this.linkPosition.angle);
                    this.$emit('updateLinkPosition', this.linkPosition);
                    this.linkMoving = false;
                }
            }
          })
          interact(".draggable-link").draggable({
              modifiers: [
                interact.modifiers.restrictRect({
                  restriction: this.$refs['screen'],
                  // endOnly: true
                }),
              ],
              listeners: {
                move: [this.moveLinkHandle, this.moveWidget],

                // call this function on every dragend event
                end: (event) => {
                  console.log(event);
                  console.log(this.linkPosition);
                },
              },
            }).resizable({
              edges: { left: '.edge-left', right: '.edge-right', bottom: '.edge-bottom', top: '.edge-top'},
              listeners: { move: this.linkResizable },
              modifiers: [
                interact.modifiers.restrictEdges({
                  outer: 'parent',
                }),
                interact.modifiers.restrictSize({
                  min: { width: 50, height: 10 },
                  max: { width: 300, height: 55 }
                }),
                interact.modifiers.aspectRatio({
                  ratio: 'preserve'
                })
              ]
            });
        });
      }
    }
    console.log(this.slider);
    if (this.slider) {
      console.log(this.slider, this.sliderColorPossibles.findIndex(e => e === this.slider.color));
      this.sliderColor = this.sliderColorPossibles.findIndex(e => e === this.slider.color)
    }
    if (this.slider && !this.onlyViewMode) {
      this.sliderPosition.x = this.slider.x
      this.sliderPosition.y = this.slider.y
      this.$nextTick(() => {
        interact(".draggable-slider").draggable({
            modifiers: [
              interact.modifiers.restrictRect({
                restriction: this.$refs['screen'],
                // endOnly: true
              }),
            ],
            listeners: {
              move: [this.moveSliderHandle, this.moveWidget],

              // call this function on every dragend event
              end: (event) => {
                console.log(event);
                // console.log(this.linkPosition);
              },
            },
          });
        let sliderElement = this.$refs.slider;
        this.moveSliderHandle({target: sliderElement, dx: (this.slider.x || this.screenWidth/2) - sliderElement.offsetWidth/2, dy: (this.slider.y || this.screenWidth/-2)  - sliderElement.offsetHeight/2}, true);
        this.sliderMoving = false; 
      });
    }
    console.log('poll', this.poll);
    if (this.poll && !this.onlyViewMode) {
      this.pollPosition.x = this.poll.x
      this.pollPosition.y = this.poll.y
      this.$nextTick(() => {
        interact(".draggable-poll").draggable({
            modifiers: [
              interact.modifiers.restrictRect({
                restriction: this.$refs['screen'],
                // endOnly: true
              }),
            ],
            listeners: {
              move: [this.movePollHandle, this.moveWidget],

              // call this function on every dragend event
              end: (event) => {
                console.log(event);
                // console.log(this.linkPosition);
              },
            },
          });
        let pollElement = this.$refs.poll;
        this.movePollHandle({target: pollElement, dx: (this.poll.x || this.screenWidth/2) - pollElement.offsetWidth/2, dy: (this.poll.y || this.screenWidth/-2)  - pollElement.offsetHeight/2}, true);
        this.pollMoving = false;
      });
    }
    if (this.poll && this.poll.options && this.poll.options[0]) {
      // let el = document.getElementById('poll-option-1');
      this.$nextTick(() => {
        let el = this.$refs["poll-option-1"];
        if (!el) el = document.getElementById('poll-option-1');
        this.pollOptionSize(el, '', this.poll.options[0]);
      })
      
    }
    if (this.poll && this.poll.options && this.poll.options[1]) {
      // let el = document.getElementById('poll-option-2');
      this.$nextTick(() => {
        let el = this.$refs["poll-option-2"];
        if (!el) el = document.getElementById('poll-option-2');
        this.pollOptionSize(el, '', this.poll.options[1]);
      })
    }
    console.log(this.onlyViewMode);
    if (this.onlyViewMode || this.draft) {
      if (this.templateConfig && (this.injectedText[0].x !== ((this.templateConfig.configuration.text.x / (1440 / this.screenWidth)) - (this.templateConfig.configuration.text.w / (1440 / this.screenWidth) / 2) ) || this.injectedText[0].y !== ((this.templateConfig.configuration.text.y / (1440 / this.screenWidth)) - (this.templateConfig.configuration.text.h / (1440 / this.screenWidth) / 2) ))) {
        this.textStatic = false;
      }
      this.$nextTick(this.transformImage);
    } 
    if (!this.onlyViewMode) {
      interact('.image-layer-false')
        .resizable({
          edges: { left: true, right: false, bottom: false, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 20, height: 20 },
              // max: { width: 300, height: 200 }
            }),
            interact.modifiers.aspectRatio({
              ratio: 'preserve'
            })
          ]
        })
        .draggable({
          listeners: { move: [this.imageDragHandle, this.moveWidget] },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      interact('.image-gif-false')
        .resizable({
          edges: { left: true, right: true, bottom: true, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 20, height: 20 },
              // max: { width: 300, height: 200 }
            }),
            interact.modifiers.aspectRatio({
              ratio: 'preserve'
            })
          ]
        })
        .draggable({
          listeners: { move: [this.imageDragHandle, this.moveWidget] },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      interact('.mention-widget-false')
        .draggable({
          listeners: { move: [this.imageDragHandle, this.moveWidget] },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
    }
    if (this.manualLayers.length > 0 && this.manualLayers[0].x) {
      this.$nextTick(_ => {
        this.manualLayers.forEach((e,i) => {
          let elmt = document.getElementById(`layer-${i}-${this.onlyViewMode}`);
          elmt.style.width = `${e.w/3.33}px`;
          elmt.style.height = `${e.h/3.33}px`;
          elmt.style.left = `${e.x/3.33}px`;
          elmt.style.top = `${e.y/3.33}px`;
        });
      })
    }
    if (this.gifs.length > 0 && this.gifs[0].x) {
      this.$nextTick(_ => {
        this.gifs.forEach((e,i) => {
          let elmt = document.getElementById(`gif-${i}-${this.onlyViewMode}`);
          elmt.style.width = `${e.w/3.33}px`;
          elmt.style.height = `${e.h/3.33}px`;
          elmt.style.left = `${e.x/3.33}px`;
          elmt.style.top = `${e.y/3.33}px`;
        });
      })
    }
    if (this.mentionsWidget.length > 0 && this.mentionsWidget[0].x) {
      this.$nextTick(_ => {
        this.mentionsWidget.forEach((e,i) => {
          let elmt = document.getElementById(`mention-widget-${i}-${this.onlyViewMode}`);
          elmt.style.width = `${e.w/3.33}px`;
          elmt.style.height = `${e.h/3.33}px`;
          elmt.style.left = `${e.x/3.33}px`;
          elmt.style.top = `${e.y/3.33}px`;
        });
      })
    }
    console.log(this.injectedBackground);
    this.imageAverageColor = `rgb(${this.injectedBackground[0]}, ${this.injectedBackground[1]}, ${this.injectedBackground[2]})`;
  },

  data() {
    return {
      pollMoving: false,
      centerWidget: false,
      musicPaused : false,
      percentMusicPlaying: "0%",
      linkColor: 0,
      sliderColor: 0,
      sliderColorPossibles: ["#ffffff", '#000000', "#E50075", "#d734cd", "#8147f6", "#ee8132", "#5ece55", "#47a1f8", "#59c5f7"],
      linkMoving: false,
      sliderMoving: false,
      mentionsWidgetMoving: false,
      mentionSelected: null,
      layerSelected: null,
      picProfil: "https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/avatar_instagram.png",
      shareUser: null,
      shareImageHeight: 0,
      gradientSharedImageColor: ["#FFF", "#FFF"],
      newHighlight: '',
      currentHighlight: null,
      highlightsPage: [],
      highlightPopup: false,
      image: null,
      confirmDelete: false,
      text: [],
      textMode: false,
      dragText: null,
      clickPossible: true,
      colors: [
        '#fdcb5c',
        '#fd8d32',
        '#db565b',
        '#d10869',
        '#a207ba',
        '#0095ff',
        '#58c322',
        'black',
        'white'
      ],
      trashOver: false,
      oldWidthText: [],
      link: null,
      linkPosition: {
        x: null,
        y: null,
      },
      pollPosition: {
        x: null,
        y: null
      },
      sliderPosition:{
        x: null,
        y: null
      },
      cropMode: false,
      cropper: null,
      cropZoom: 0.01,
      justify: "center",
      colorSwitch: false,
      imageNoUrl: false,
      rotateText: null,
      currentTextIndex: 0,
      imageModification: true,
      imageAverageColor: 'black',
      leftLinkPos: '50%',
      layers: [],
      textStatic: true,
      musicConfigRange: [0, 0],
      activeEdit: {
        title: false,
        scheduling: false
      },
      editValue: {
        storification: {
          date: moment().add(12, 'minutes').second(0).utc().local().format(),
          time: {
            HH: moment().add(12, 'minutes').utc().local().hour() < 10 
                                    ? `0${moment().add(12, 'minutes').utc().local().hour()}`
                                    : `${moment().add(12, 'minutes').utc().local().hour()}`,
            mm: moment().add(12, 'minutes').utc().local().minute() < 10 
                                    ?`0${moment().add(12, 'minutes').utc().local().minute()}`
                                    : `${moment().add(12, 'minutes').utc().local().minute()}`
          }
        },
        title: null,
        scheduling: {
          date: moment().add(12, 'minutes').second(0).utc().local().format(),
          time: {
            HH: moment().add(12, 'minutes').utc().local().hour() < 10 
                                    ? `0${moment().add(12, 'minutes').utc().local().hour()}`
                                    : `${moment().add(12, 'minutes').utc().local().hour()}`,
            mm: moment().add(12, 'minutes').utc().local().minute() < 10 
                                    ?`0${moment().add(12, 'minutes').utc().local().minute()}`
                                    : `${moment().add(12, 'minutes').utc().local().minute()}`
          }
        },
      },
      emojiIndex: new EmojiIndex(emojiData),
      showEmojiPicker: false,
      bot: null,

      gifSelected: null,
    }
  },

  watch: {

    linkText: function (newVal, oldVal) {
      console.log(newVal, "linktext");
      this.$nextTick(() => {
        let linkEl = document.getElementById("link-container");
        if (linkEl) {
          this.moveLinkHandle({target: linkEl, dx: 0, dy: 0}, false);
        }
      });
    },

    music: function (newVal, oldVal) {
      if (newVal && newVal.startTime && newVal.duration) {
        console.log(newVal.startTime, newVal.duration);
        this.musicConfigRange = [newVal.startTime, newVal.startTime + newVal.duration];
        this.$nextTick(this.setMusicTimer)
      }
    },

    isShare: function (newVal, oldVal) {
      if (newVal) {
        this.getSharedUsername();
      }
    },

    'poll.options.0': {
       handler: function(val, old) {
        let el = document.getElementById('poll-option-1');
        this.pollOptionSize(el, old, val);
        // if (!el) return;
        // if (!old || !val) {
        //   el.style.fontSize = '22.4px'; 
        //   return;
        // }
        // let text = val.toUpperCase();
        // const maxWidth = el.offsetWidth - 1;
        // const font = this.getCanvasFont(el);
        // let w = this.getTextMetrics(text, font).width;
        // let lineNumber = Math.ceil(w/maxWidth);
        // let currentLineWidth = w-(maxWidth*(lineNumber-1))
        // console.log(text, el, font, w, maxWidth, currentLineWidth, lineNumber);
        // let fontSize = parseFloat(font.split(' ')[1].replace(/[^0-9^.]/g,''));
        // if (val.length > old.length && Math.round(w) >= maxWidth) {
        //   // if (fontSize === 10.56) {
        //   //   this.poll.options[0] = old;
        //   //   return;
        //   // }
        //   let diff =  w - maxWidth;
        //   console.log(fontSize, diff)
        //   el.style.fontSize = `${Math.min(Math.max(10.56, fontSize-diff), 22.4)}px`
        // } else if (val.length < old.length) {
        //   let diff = currentLineWidth - maxWidth;
        //   if (diff < 0 && lineNumber === 1) {
        //     diff = Math.max(diff, -5)
        //     el.style.fontSize = `${Math.min(fontSize+1, 22.4)}px`
        //   }

        // }
      }
    },

    'poll.options.1': {
       handler: function(val, old) {
        let el = document.getElementById('poll-option-2');
        this.pollOptionSize(el, old, val);
      }
    },

    template: {
      handler: function(val) {
        this.transformImage();
      }
    },
    
    text: {
      handler: function(val) {
        console.log('txt: ', val);
        if (this.onlyViewMode) return
        
        this.$nextTick(() => {
          let txtEl = this.textElement()
          let textPos = this.textElement(this.currentTextIndex)
          if (this.textMode) {
            textPos = textPos.parentElement;
          }
          let screenPosition = document.getElementsByClassName('screen-instagram')[0].getBoundingClientRect()
          if (this.text[this.currentTextIndex].x + textPos.offsetWidth >= screenPosition.width - 10) {
            this.text[this.currentTextIndex].x = this.text[this.currentTextIndex].x - 2;
          }
          this.oldWidthText.push(30);
          // this.textExpandSize()
          // console.log(txtEl);
          this.$emit('changeText', val, this.currentTextIndex ,txtEl.offsetWidth, txtEl.offsetHeight);
        })
        
      }, deep: true 
    },

    injectedBackground: {
      handler: function(val) {
        this.imageAverageColor = `rgb(${val[0]}, ${val[1]}, ${val[2]})`;
      }
    },

    manualLayers: {
      handler: function(val, oldValue) {
        // console.log("manualLayer",oldValue, val);
        if (val.length > 0 && val[0].x && this.onlyViewMode) {
          this.$nextTick(_ => {
            val.forEach((e,i) => {
              let elmt = document.getElementById(`layer-${i}-${this.onlyViewMode}`);
              elmt.style.width = `${e.w/3.33}px`;
              elmt.style.height = `${e.h/3.33}px`;
              elmt.style.left = `${e.x/3.33}px`;
              elmt.style.top = `${e.y/3.33}px`;
            });
          })
        }
      }
    },

    gifs: {
      handler: function(val, oldValue) {
        // console.log("manualLayer",oldValue, val);
        if (val.length > 0 && val[0].x && this.onlyViewMode) {
          this.$nextTick(_ => {
            val.forEach((e,i) => {
              let elmt = document.getElementById(`gif-${i}-${this.onlyViewMode}`);
              elmt.style.width = `${e.w/3.33}px`;
              elmt.style.height = `${e.h/3.33}px`;
              elmt.style.left = `${e.x/3.33}px`;
              elmt.style.top = `${e.y/3.33}px`;
            });
          })
        }
      }
    },

    mentionsWidget: {
      handler: function(val, oldValue) {
        console.log("mentionsWidget",oldValue, val);
        if (val.length > 0 && val[0].x && this.onlyViewMode) {
          this.$nextTick(_ => {
            val.forEach((e,i) => {
              let elmt = document.getElementById(`mention-widget-${i}-${this.onlyViewMode}`);
              elmt.style.width = `${e.w/3.33}px`;
              elmt.style.height = `${e.h/3.33}px`;
              elmt.style.left = `${e.x/3.33}px`;
              elmt.style.top = `${e.y/3.33}px`;
            });
          })
        }
      }, deep: true
    },

    injectedText: { 
      handler: function (newVal, oldVal) {
        this.text = [];
        this.oldWidthText = [];
        if (!newVal) {
          return;
        }
        // console.log(newVal)
        for (let txt of newVal) {
          this.text.push({
            x: txt.x ? txt.x : this.screenWidth / 2 - 10,
            y: txt.y ? txt.y : this.screenHeight / 2 - 10,
            content: txt.content,
            color: txt.color ? txt.color : 'white',
            // color: 'red',
            size: txt.size ? txt.size : 22,
            font: txt.font ? txt.font : 1,
            background: txt.background ? txt.background : 0,
            angle: txt.angle ? txt.angle : 0,
            w: txt.w,
            h: txt.h
          })
          this.oldWidthText.push(30);
          // this.textExpandSize()
        }
        // setTimeout(() => this.textExpandSize(), 100)

      }, deep: true
    },
    injectedLink: function (newVal, oldVal) {
      console.log('link', newVal, !this.imageNoUrl && newVal !== '', this.imageNoUrl, this.video, this.isVideo);
      this.link = newVal
      this.$nextTick(() => {
        console.log("link 2",this.video, this.isVideo);
        if (!this.imageNoUrl && newVal !== '' && !(this.video && this.isVideo)) {
          let meta = this.getMeta(newVal)
          // console.log('meta', meta)
        }
      })
      
      if (!this.onlyViewMode && newVal) {
        // if (this.posiLink) {
        //   this.$nextTick(() => {
        //     console.log('posilink', this.posiLink);
        //     let linkEl = document.getElementById("link-container");
        //     if (linkEl) {
        //       linkEl.style.left = `${this.posiLink.x}px`;
        //       linkEl.style.top = `${this.posiLink.y}px`;
        //       linkEl.style.transform = 'none';
        //     }
        //   })
        // }
        this.$nextTick(() => {
          interact('#link-rotate').draggable({
            listeners: {
                start: (event) => {
                    this.linkMoving = true;
                    let box = document.getElementById("link-container");

                    let rect = box.getBoundingClientRect();
              
                    // store the center as the element has css `transform-origin: center center`
                    box.setAttribute('data-center-x', rect.left + rect.width / 2);
                    box.setAttribute('data-center-y', rect.top + rect.height / 2);
                    // get the angle of the element when the drag starts
                    box.setAttribute('data-angle', this.getDragAngle(event, box));
                  },
                // call this function on every dragmove event
                move: (e) => {
                  console.log(e,'rotatemove');
                    let box = document.getElementById("link-container");


                    let pos = {
                        x: parseFloat(box.getAttribute('data-x')) || 0,
                        y: parseFloat(box.getAttribute('data-y')) || 0
                    };
                    let scale = (parseFloat(box.getAttribute('data-scale')) || 1)

                    let angle = this.getDragAngle(e, box);

                    // update transform style on dragmove
                    box.style.transform = 'translate(' + pos.x + 'px, ' + pos.y + 'px) rotate(' + angle + 'rad' + ') scale(' + scale +')';
                },

                // call this function on every dragend event
                end: (event) => {
                    let box = document.getElementById("link-container");

                    // save the angle on dragend
                    let angle = this.getDragAngle(event, box);
                    box.setAttribute('data-angle', angle);
                    this.linkPosition.angle = angle;
                    console.log('link',this.linkPosition.angle);
                    this.$emit('updateLinkPosition', this.linkPosition);
                    this.linkMoving = false;
                }
            }
          })
          interact(".draggable-link").draggable({
              modifiers: [
                interact.modifiers.restrictRect({
                  restriction: this.$refs['screen'],
                  // endOnly: true
                }),
              ],
              listeners: {
                move: [this.moveLinkHandle, this.moveWidget],

                // call this function on every dragend event
                end: (event) => {
                  console.log('end',event);
                  console.log(this.linkPosition);
                  
                },
              },
            }).resizable({
              edges: { left: '.edge-left', right: '.edge-right', bottom: '.edge-bottom', top: '.edge-top'},
              listeners: { move: this.linkResizable },
              modifiers: [
                interact.modifiers.restrictEdges({
                  outer: 'parent',
                }),
                interact.modifiers.restrictSize({
                  min: { width: 50, height: 10 },
                  max: { width: 300, height: 55 }
                }),
                interact.modifiers.aspectRatio({
                  ratio: 'preserve'
                })
              ]
            });
          this.moveLinkHandle({target: document.getElementById('link-container'), dx: 0, dy: 0}, true);
          this.linkMoving = false;
        });
      }
    },
    injectedImage: function (newVal, oldVal) {
      console.log('newimg',this.autoCrop,newVal, typeof newVal)
      if (typeof newVal !== 'string') {
        newVal = URL.createObjectURL(newVal) || newVal;
      }
      if (!this.autoCrop) return;
      // this.image = newVal
      
      // if (this.image) {
      //   this.cropForFormat();
      // }
      const regUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/gm;
      if (regUrl.test(newVal)) {
        console.log('img url');
        this.$vs.loading({container: this.$refs.screen, color: '#43153D'})
        this.getImageFromUrl(encodeURIComponent(newVal)).then(result => {
          this.$vs.loading.close(this.$refs.screen);
          this.image = result.body.image;
          this.cropForFormat();
        });
      } else {
        this.image = newVal
        this.cropForFormat();  
      }
      
    },

    poll: function (newVal, oldVal) {
      console.log('poll Watch', newVal, oldVal);
      if (oldVal || this.onlyViewMode) return;
      this.pollPosition.x = newVal.x
      this.pollPosition.y = newVal.y
      this.$nextTick(() => {
        interact(".draggable-poll").draggable({
            modifiers: [
              interact.modifiers.restrictRect({
                restriction: this.$refs['screen'],
                // endOnly: true
              }),
            ],
            listeners: {
              move: [this.movePollHandle, this.moveWidget],

              // call this function on every dragend event
              end: (event) => {
                console.log('end',event);
                console.log(this.linkPosition);
                
              },
            },
          });
        let pollElement =this.$refs.poll;
        this.movePollHandle({target: pollElement, dx: (this.poll.x || this.screenWidth/2) - pollElement.offsetWidth/2, dy: (this.poll.y || this.screenWidth/-2)  - pollElement.offsetHeight/2}, true);
        this.pollMoving = false;
        // this.movePollHandle({target: document.getElementById('poll-container'), dx: this.screenWidth/2 - document.getElementById('poll-container').offsetWidth/2, dy: this.screenWidth/-2  - document.getElementById('poll-container').offsetHeight/2});
      });
    },

    slider: function (newVal, oldVal) {
      console.log('slider Watch', newVal, oldVal);
      if (oldVal || this.onlyViewMode) return;
      this.sliderPosition.x = newVal.x
      this.sliderPosition.y = newVal.y
      this.$nextTick(() => {
        interact(".draggable-slider").draggable({
            modifiers: [
              interact.modifiers.restrictRect({
                restriction: this.$refs['screen'],
                // endOnly: true
              }),
            ],
            listeners: {
              move: [this.moveSliderHandle, this.moveWidget],

              // call this function on every dragend event
              end: (event) => {
                console.log('end',event);
                console.log(this.linkPosition);
                
              },
            },
          });
        let sliderElement =this.$refs.slider;
        this.moveSliderHandle({target: sliderElement, dx: (this.slider.x || this.screenWidth/2) - sliderElement.offsetWidth/2, dy: (this.slider.y || this.screenWidth/-2)  - sliderElement.offsetHeight/2}, true);
        this.sliderMoving= false;
        // this.movePollHandle({target: document.getElementById('poll-container'), dx: this.screenWidth/2 - document.getElementById('poll-container').offsetWidth/2, dy: this.screenWidth/-2  - document.getElementById('poll-container').offsetHeight/2});
      });
    },

  },

  methods: {

    setMentionSelected(e, id) {
      this.deselectDragObjects(null);
      this.mentionSelected = id;
      e.stopPropagation();
    },

    setLayerSelected(e, id) {
      this.deselectDragObjects(null);
      this.layerSelected = id;
      console.log(id);
      e.stopPropagation();
    },

    deleteWidget(e) {
      let toDeleteText = null;
      let ToDeleteArg = null;
      if (this.dragText) {
        toDeleteText = "deleteText";
      } else if (this.pollMoving) {
        toDeleteText = "removePoll"
      } else if (this.sliderMoving) {
        toDeleteText = "removeSlider"
      } else if (this.mentionsWidgetMoving && this.mentionSelected) {
        toDeleteText = "removeMention"
        ToDeleteArg = this.mentionSelected;
      } else if (this.mentionsWidgetMoving && this.gifSelected) {
        toDeleteText = "removeGif"
        ToDeleteArg = this.gifSelected;
      } else if (this.mentionsWidgetMoving && this.layerSelected !== null) {
        toDeleteText = "layerWidgetMoving"
        ToDeleteArg = this.layerSelected;
      } else if (this.linkMoving) {
        toDeleteText = "removeLink";
      }  
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        "accept-text": this.$t("dash.button.delete"),
        "cancel-text": this.$t("dash.button.cancel"),
        title: `${this.$t("dash.button.delete")} ?`,
        text: this.$t("dash.story.remove.widget.confirm"),
        accept: () => {
          console.log("delteWidget", toDeleteText, ToDeleteArg);
          if (toDeleteText && toDeleteText === "deleteText") {
            this.deleteText();
          } else if (toDeleteText && ToDeleteArg) {
            this.$emit(toDeleteText, ToDeleteArg)
          } else if (toDeleteText) {
            this.$emit(toDeleteText)
          }
        }
      })
      
    },

    moveWidget(e, text=false) {
      let posiX;
      let posiY;
      if (text) {
        let screenPosition = document.getElementsByClassName('screen-instagram')[0].getBoundingClientRect()
        const x = Math.max(Math.min(e.clientX - screenPosition.x - this.dragText.target.offsetWidth / 2, this.screenWidth - this.dragText.target.offsetWidth), 1);
        if (this.dragText.target.parentElement.offsetWidth + x >= screenPosition.width - 10) {
          posiX = screenPosition.width - this.dragText.target.parentElement.offsetWidth - 11;
        } else {
          posiX = x
        }
        posiX += (this.dragText.target.parentElement.offsetWidth / 2) + 3;
        posiY = Math.max(Math.min(e.clientY - screenPosition.y - this.dragText.target.offsetHeight / 2, this.screenHeight - this.dragText.target.offsetHeight), this.screenHeight * 0.01)

      } else {
        let target = e.target;
        let x = (parseFloat(target.getAttribute('data-x')) || 0) + e.dx
        let y = (parseFloat(target.getAttribute('data-y')) || 0) + e.dy
        posiX = target.offsetLeft + x +( target.offsetWidth / 2) + 5;
        posiY = target.offsetTop + y + (target.offsetHeight / 2);
      }
      console.log(posiX, (this.screenWidth/2));
      const shift = 2;
      if ((posiX > ((this.screenWidth/2) - shift)) && (posiX < ((this.screenWidth/2) + shift))) {
        this.centerWidget = true;
      } else {
        this.centerWidget = false;
      }
    },
    
    getDragAngle(event, box) {
      let startAngle = parseFloat(box.getAttribute('data-angle')) || 0;
      let center = {
        x: parseFloat(box.getAttribute('data-center-x')) || 0,
        y: parseFloat(box.getAttribute('data-center-y')) || 0
      };
      let angle = Math.atan2(center.y - event.clientY,
        center.x - event.clientX);
    
      return angle - startAngle;
    },

    deselectDragObjects(e) {
      if (e) {
        let no_deselect = e.target.getAttribute("no-deselect");
        if (no_deselect === null) {
          this.confirmText();
        }
      }
      this.gifSelected = null;
      this.mentionSelected = null;
      this.layerSelected = null;
    },

    updateGifs(gifs) {
      gifs.forEach((e,i) => {
        let elmt = document.getElementById(`gif-${i}-${this.onlyViewMode}`);
        elmt.style.width = `${e.w/3.33}px`;
        elmt.style.height = `${e.h/3.33}px`;
        elmt.style.left = `${e.x/3.33}px`;
        elmt.style.top = `${e.y/3.33}px`;
      });
    },

    updateMentionsWidget(mentions) {
      mentions.forEach((e,i) => {
        let elmt = document.getElementById(`mention-widget-${i}-${this.onlyViewMode}`);
        elmt.style.left = `${e.x/3.33}px`;
        elmt.style.top = `${e.y/3.33}px`;
      });
    },

    setGifBorder(e, id) {
      this.deselectDragObjects(null);
      this.gifSelected = id;
      e.stopPropagation()
    },

    getMusicInformations() {
      let [start, end] = this.musicConfigRange;
      return {duration: end-start, start}
    },

    setDurationMusic(duration) {
      console.log(duration);
      let [start, end] = this.musicConfigRange;
      this.musicConfigRange = [start, start + duration*1000];
      this.setMusicTimer();
      // this.$emit("setMusicDuration", duration*1000);
    },

    setMusicSeek(e) {
      if (this.music) {
        // console.log(e.target.currentTime * 1000)
        const videoTime = e.target.currentTime * 1000;
        let [start, end] = this.musicConfigRange;
        let audio = this.$refs['music-story-maker'];
        audio.currentTime = (start + videoTime)/1000;
        this.$forceUpdate()
      }
    },

    muteVideoIfMusic(e) {
      if (this.music) {
        // console.log(e.target.currentTime * 1000)
        const muted = e.target.muted;
        if (!muted) {
          e.target.muted = true;
          this.$forceUpdate()
        }
      }
    },

    pauseMusic() {
      if (this.music) {
        let audio = this.$refs['music-story-maker'];
        if (this.isVideo && this.video) {
          let videoEl = this.$refs['video-story-maker'];
          if (videoEl) {
            videoEl.pause();
          }
        }
        if (audio) {
          audio.pause();
          this.musicPaused = true;
        }
        this.$forceUpdate()
      }
    },

    playMusic() {
      if (this.music) {
        let audio = this.$refs['music-story-maker'];
        if (this.isVideo && this.video) {
          let videoEl = this.$refs['video-story-maker'];
          videoEl.play();
        }
        audio.play();
        this.musicPaused = false;
        this.$forceUpdate()
      }
    },

    setMusicTimer() {
      let [start, end] = this.musicConfigRange;
      // this.$emit("setMusicStartTime", start)
      console.log("setMusicTimer", start, end);
      let audio = this.$refs['music-story-maker'];
      if (!audio) return;
      console.log(audio);
      audio.ontimeupdate = () => {
        let current = (audio.currentTime*1000);
        let percent = 100 * (current - start) / (end - start);
        // console.log("percent music playing", percent);
        this.percentMusicPlaying = `${percent}%`
        if (audio.currentTime * 1000 >= end) {
          audio.currentTime = start/1000;
        }
      }
      audio.currentTime = start/1000;
      if (this.isVideo && this.video) {
        let videoEl = this.$refs['video-story-maker'];
        videoEl.currentTime = 0;
        videoEl.muted = true;
        videoEl.loop = true;
        videoEl.play();
      }
      audio.play();
      this.musicPaused = false;
      this.$forceUpdate()
    },

    changeLinkColor() {
      if (!this.linkMoving) {
        if (!this.linkColor) this.linkColor = 0;
        console.log("CHANGE COLR link", this.linkColor);
        this.linkColor = (this.linkColor + 1)%4
        this.$emit('changeLinkColor', this.linkColor);
      }
    },

    changeMentionWidgetColor(idx) {
      if (!this.mentionsWidgetMoving) {
        console.log("CHANGE mentions widget color");
        // this.linkColor = (this.linkColor + 1)%4
        // this.mentionsWidget[idx].color = (this.mentionsWidget[idx].color + 1 )%4
        console.log(this.mentionsWidget[idx].color);
        this.$emit('changeMentionsWidgetColor', idx);
        this.$forceUpdate();
      }
    },

    changeSliderColor() {
      if (!this.sliderMoving) {
        console.log("Change color slider");
        this.sliderColor = (this.sliderColor + 1)%9;
        this.$emit('changeSliderColor', this.sliderColorPossibles[this.sliderColor]);
      }
    },

    async getSharedUsername() {
      console.log("SHAREDUSER",this.isShare);
      if (this.isShare.startsWith("$_$")) {
        this.shareUser = this.isShare.split(':')[3]
        this.getAvatarInstagram({id: this.pageInfo.id, username: this.shareUser}).then(result => {
          this.picProfil = result.body.profile_pic
        })
      } else {
        this.getUsernameInstagram({id: this.pageInfo.id, post_id: this.isShare}).then(result => {
            // console.log(result.body);
            this.shareUser = result.body.username;
            if (this.shareUser === this.pageInfo.name && this.pageInfo.avatar) {
              this.picProfil = this.pageInfo.avatar
            }
            // this.picProfil = result.body.pic || "https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/avatar_instagram.png"
        })
      }
    },

     transformMentionAndHashtag(message) {
      let maxWhile = 100
      let countWhile = 0
      while(message.includes('@[MENTIONS-') && countWhile<maxWhile){
        countWhile++
        let start = message.indexOf('@[MENTIONS')
        let end = message.indexOf(']', start)
        let index = parseInt(message.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
        let mention = {value: ''}
        if(this.validMentions[index-1])
          mention = this.validMentions[index-1].find(m => m.network == 'instagram') 
        message = message.substr(0, start) + (mention ? (mention.value ? mention.value : mention.word) : this.validMentions[index-1][0].word) + message.substr(end+1)
      }
      //replace multi-hashtags
      countWhile = 0
      while(message.includes('#[HASHTAGS-') && countWhile<maxWhile){
        countWhile++
        let start = message.indexOf('#[HASHTAGS')
        let end = message.indexOf(']', start)
        let index = parseInt(message.substr(start, end+1).replace('#[HASHTAGS-', '').replace(']', ''))
        let mention = {value: ''}
        if(this.validHashtags[index-1])
          mention = this.validHashtags[index-1].find(m => m.network == 'instagram') 
        message = message.substr(0, start) + (mention ? (mention.value ? mention.value : `#${mention.word}`) : this.validHashtags[index-1][0].word) + message.substr(end+1)
      }
      return message;
    },

    shareLoadImage(e) {
      console.log("SHAREEE", e);
      let colorThief = new ColorThief();
      let colors = colorThief.getPalette(e.target, 5).map(c => {
        return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
      })
      console.log("colors", colors);
      this.gradientSharedImageColor = [colors.slice(-1)[0], colors[0]]
      this.shareImageHeight = e.target.height;
    },

    pollOptionSize(el, old, val) {
      // console.log(el, old, val, 'pollOptionSize');
      // if (!el) return;
      // if (!old) old = '';
      //   if (!val) {
      //     el.style.fontSize = '22.4px'; 
      //     return;
      //   }
      //   let text = val.toUpperCase();
      //   const maxWidth = el.offsetWidth - 1;
      //   const font = this.getCanvasFont(el);
      //   let w = this.getTextMetrics(text, font).width;
      //   let lineNumber = Math.ceil(w/maxWidth);
      //   let currentLineWidth = w-(maxWidth*(lineNumber-1))
      //   // console.log(text, el, font, w, maxWidth, currentLineWidth, lineNumber);
      //   let fontSize = parseFloat(font.split(' ')[1].replace(/[^0-9^.]/g,''));
      //   if (val.length > old.length && Math.round(w) >= maxWidth) {
      //     // if (fontSize === 10.56) {
      //     //   this.poll.options[0] = old;
      //     //   return;
      //     // }
      //     let diff =  w - maxWidth;
      //     console.log(fontSize, diff)
      //     el.style.fontSize = `${Math.min(Math.max(10.56, fontSize-diff), 22.4)}px`
      //   } else if (val.length < old.length) {
      //     let diff = currentLineWidth - maxWidth;
      //     console.log(diff, lineNumber);
      //     if (diff < 0 && lineNumber === 1) {
      //       diff = Math.max(diff, -5)
      //       el.style.fontSize = `${Math.min(fontSize+1, 22.4)}px`
      //     }

      //   }
    },

   getTextMetrics(text, font) {
      // re-use canvas object for better performance
      const canvas = this.getTextMetrics.canvas || (this.getTextMetrics.canvas = document.createElement("canvas"));
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return metrics;
    },

    getCssStyle(element, prop) {
        return window.getComputedStyle(element, null).getPropertyValue(prop);
    },

    getCanvasFont(el) {
      const fontWeight = this.getCssStyle(el, 'font-weight') || 'normal';
      const fontSize = this.getCssStyle(el, 'font-size') || '16px';
      const fontFamily = this.getCssStyle(el, 'font-family') || 'Times New Roman';
      
      return `${fontWeight} ${fontSize} ${fontFamily}`;
    },

    async getLayersInformations() {
      let bodylayers = this.manualLayers.map((e,i) => {
        let element = document.getElementById(`layer-${i}-false`);
        delete e.x;
        delete e.y;
        delete e.h;
        delete e.w;
        return {
          x: Math.max(parseInt((element.offsetLeft + parseFloat(element.getAttribute('data-x') || 0)) * 3.33), 1),
          y: Math.max(parseInt((element.offsetTop + parseFloat(element.getAttribute('data-y') || 0)) * 3.33), 1),
          w: parseInt(element.offsetWidth * 3.33),
          h: parseInt(element.offsetHeight * 3.33),
          ...e
          // url: e.url
        }
      });
      // console.log(bodylayers[0].x);
      return bodylayers;
    },

    async getGifsInformations() {
      let bodyGifs = this.gifs.map((e,i) => {
        let element = document.getElementById(`gif-${i}-false`);
        delete e.x;
        delete e.y;
        delete e.h;
        delete e.w;
        return {
          x: Math.max(parseInt((element.offsetLeft + parseFloat(element.getAttribute('data-x') || 0)) * 3.33), 1),
          y: Math.max(parseInt((element.offsetTop + parseFloat(element.getAttribute('data-y') || 0)) * 3.33), 1),
          w: parseInt(element.offsetWidth * 3.33),
          h: parseInt(element.offsetHeight * 3.33),
          ...e
          // url: e.url
        }
      });
      // console.log(bodylayers[0].x);
      return bodyGifs;
    },

    linkResizable(event) {
      this.linkMoving = true;
      let target = event.target
      let x = parseFloat(target.getAttribute('data-x')) || 0
      let y = parseFloat(target.getAttribute('data-y')) || 0

      // update the element's style
      // target.style.width = event.rect.width + 'px'
      // target.style.height = event.rect.height + 'px'
      let scale = parseFloat(event.rect.width/(target.style.width || 146))
      console.log(event.rect.width, target.style.width);
      if (scale > 2) scale = parseFloat(target.getAttribute('data-scale') || 1);
      console.log(scale);

      // translate when resizing from top or left edges
      // x += event.deltaRect.left
      // y += event.deltaRect.top

      let angle = (parseFloat(target.getAttribute('data-angle')) || 0)

      // translate the element
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px) rotate(' + angle + 'rad' + ') scale(' + scale +')'
      // target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

      // target.setAttribute('data-x', x)
      // target.setAttribute('data-y', y)
      target.setAttribute('data-scale', scale)
      this.linkPosition.scale = scale;
      console.log('link',this.linkPosition.scale);
      this.$emit('updateLinkPosition', this.linkPosition);
    },

    async getMentionsWidgetInformations() {
      let bodyMentionsWidget = this.mentionsWidget.map((e,i) => {
        let element = document.getElementById(`mention-widget-${i}-false`);
        delete e.x;
        delete e.y;
        delete e.h;
        delete e.w;
        return {
          x: Math.max(parseInt((element.offsetLeft + parseFloat(element.getAttribute('data-x') || 0)) * 3.33), 1),
          y: Math.max(parseInt((element.offsetTop + parseFloat(element.getAttribute('data-y') || 0)) * 3.33), 1),
          w: parseInt(element.offsetWidth * 3.33),
          h: parseInt(element.offsetHeight * 3.33),
          ...e
          // url: e.url
        }
      });
      // console.log(bodylayers[0].x);
      return bodyMentionsWidget;
    },

    async imageResizeHandle(event) {
      if (this.onlyViewMode) return;
      let target = event.target
      let x = parseFloat(target.getAttribute('data-x')) || 0
      let y = parseFloat(target.getAttribute('data-y')) || 0

      // update the element's style
      target.style.width = event.rect.width + 'px'
      target.style.height = event.rect.height + 'px'

      // translate when resizing from top or left edges
      x += event.deltaRect.left
      y += event.deltaRect.top

      target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      target.textContent =
        Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)

      if (this.gifs) {
        let gifsToSend = await this.getGifsInformations();
        this.$emit('updateGifs', gifsToSend);
      }
      if (this.manualLayers) {
        let layersToSend = await this.getLayersInformations();
        this.$emit('updateLayers', layersToSend);
      }
    },
    
    async imageDragHandle(event) {
      if (this.onlyViewMode) return;
      let target = event.target
      this.mentionsWidgetMoving = true;
      // keep the dragged position in the data-x/data-y attributes
      let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)

      if (this.gifs) {
        let gifsToSend = await this.getGifsInformations();
        this.$emit('updateGifs', gifsToSend);
      }
      if (this.manualLayers) {
        let layersToSend = await this.getLayersInformations();
        console.log(layersToSend);
        this.$emit('updateLayers', layersToSend);
      }
      if (this.mentionsWidget) {
        let mentionsWidgetToSend = await this.getMentionsWidgetInformations();
        this.$emit('updateWidgetMention', mentionsWidgetToSend);
      }
      
      
    },

    async transformImage() {
      let image = this.$refs['main-img']
      // let link = document.getElementById('link-container');
      let link = this.$refs.link;
      console.log('transformimage',this.templateConfig && this.template === 'custom');
      if (this.templateConfig && this.template === 'custom') {
        console.log('custom', this.templateConfig.configuration, image, link);
        image.style.width = `${this.templateConfig.configuration.image.w / (1080 / this.screenWidth)}px`;
        image.style.height = `${this.templateConfig.configuration.image.h / (1080 / this.screenWidth)}px`;
        image.style.left = `${this.templateConfig.configuration.image.x / (1080 / this.screenWidth)}px`;
        image.style.top = `${this.templateConfig.configuration.image.y / (1080 / this.screenWidth)}px`;
        image.style.objectFit = "cover";
        image.style.borderRadius = "0px";
        image.style.position = "absolute";

        if (!this.draft &&  !this.onlyViewMode) {

          this.text[this.currentTextIndex].w = (this.templateConfig.configuration.text.w / (1440 / this.screenWidth));
          this.text[this.currentTextIndex].h = (this.templateConfig.configuration.text.h / (1440 / this.screenWidth));
          this.text[this.currentTextIndex].x = ((this.templateConfig.configuration.text.x / (1440 / this.screenWidth)) - (this.templateConfig.configuration.text.w / (1440 / this.screenWidth) / 2) );
          this.text[this.currentTextIndex].y = ((this.templateConfig.configuration.text.y / (1440 / this.screenWidth)) - (this.templateConfig.configuration.text.h / (1440 / this.screenWidth) / 2) );
          this.text[this.currentTextIndex].color = this.templateConfig.configuration.text.color;
          this.text[this.currentTextIndex].background = 0;
          this.text[this.currentTextIndex].font = this.templateConfig.configuration.text.font;
          this.text[this.currentTextIndex].size = this.templateConfig.configuration.text.size / (500 / this.screenWidth);
          if (link) {
            console.log('linkn');
            link.style.left = `${parseInt(this.templateConfig.configuration.link.x / (1440 / this.screenWidth))}px`;
            link.style.top = `${parseInt(this.templateConfig.configuration.link.y / (1440 / this.screenWidth))}px`;
            this.linkPosition.x = this.templateConfig.configuration.link.x / (1440 / this.screenWidth);
            this.linkPosition.y = this.templateConfig.configuration.link.y / (1440 / this.screenWidth);
            this.$emit('updateLinkPosition', this.linkPosition);
          }
        }
        this.imageAverageColor = this.templateConfig.configuration.background;
        this.layers = this.templateConfig.configuration.layers;
        console.log('custom', this.templateConfig.configuration, image, link);

      } else {
        // && !image.classList.includes('icons-white')
        if (image && !image.classList.contains('icons-white') && !this.isShare) {
          image.style.width = `100%`;
          image.style.height = `100%`;
          image.style.left = `0px`;
          image.style.top = `0px`;
          image.style.objectFit = "contain";
          image.style.borderRadius = "5px";
          image.style.position = "";
        }
        this.layers = [];
        if (this.injectedBackground && this.injectedBackground.length >= 3) {
          this.imageAverageColor = `rgb(${this.injectedBackground[0]}, ${this.injectedBackground[1]}, ${this.injectedBackground[2]})`;
        }
        if (!this.isShare && image && !this.onlyViewMode && !this.injectedBackground) {
          const fac = new FastAverageColor();
          let facColor = await fac.getColorAsync(image)
          this.imageAverageColor = facColor.rgb;
        }
      }
    },

  linkAction() {
    if (this.onlyViewMode) {
      window.open(
        this.link,
        '_blank' // <- This is what makes it open in a new window.
      );
    }
  },

  moveLinkHandle(event, init=false) {
    this.linkMoving = true;
    console.log("move", this.posiLink);
    let target = event.target
    // if (!this.linkPosition.x && !this.linkPosition.y) {
    //   this.leftLinkPos = `${(this.$refs['screen'].offsetWidth/2) - (target.offsetWidth/2)}px`
    // }

    // const screen = this.$refs['screen'];
    // const ratioX = parseFloat(this.linkPosition.x) * screen.offsetWidth;
    // const ratioY = parseFloat(this.linkPosition.y) * screen.offsetHeight;
    // console.log('screen', screen.offsetWidth, screen.offsetHeight, target.getAttribute('data-x'), target.getAttribute('data-y'));
    // const x = (ratioX || 0) + (event ? event.dx : 0);
    // const y = (ratioY || 0) + (event ? event.dy : 0);
    // keep the dragged position in the data-x/data-y attributes
    let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
    let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
    let angle = (parseFloat(target.getAttribute('data-angle')) || 0)
    let scale = (parseFloat(target.getAttribute('data-scale')) || 1)
    // if (x === 0 && y === 0) {
    //   x = -76;
    //   y = -47;
    // }
    if (this.posiLink && init) {
      x = this.posiLink.x - target.offsetLeft - target.offsetWidth / 2;
      y = this.posiLink.y - target.offsetTop - target.offsetHeight / 2;
      angle = this.posiLink.angle || 0;
      scale = this.posiLink.scale || 1;
    }
    // translate the element
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px) rotate(' + angle + 'rad' + ') scale('+ scale +')'

    // update the posiion attributes
    target.setAttribute('data-x', x)
    target.setAttribute('data-y', y)
    target.setAttribute('data-angle', angle)
    target.setAttribute('data-scale', scale)

    this.linkPosition.x = target.offsetLeft + x + target.offsetWidth / 2;
    this.linkPosition.y = target.offsetTop + y + target.offsetHeight / 2;
    this.linkPosition.angle = angle;
    this.linkPosition.scale = scale;
    console.log('link',this.linkPosition.x, this.linkPosition.y);
    this.$emit('updateLinkPosition', this.linkPosition);

  },

   movePollHandle(event, init=false) {
    this.pollMoving = true;
    console.log("movePoll", event, this.pollPosition);
    let target = event.target
    let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
    let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

    if (this.poll && this.poll.x && this.poll.y && init) {
      x = this.pollPosition.x - target.offsetLeft - target.offsetWidth / 2;
      y = this.pollPosition.y - target.offsetTop - target.offsetHeight / 2;
    }
    // translate the element
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

    // update the posiion attributes
    target.setAttribute('data-x', x)
    target.setAttribute('data-y', y)

    console.log(target.offsetTop, y ,  target.offsetHeight / 2, target);
    this.pollPosition.x = target.offsetLeft + x + target.offsetWidth / 2;
    this.pollPosition.y = target.offsetTop + y + target.offsetHeight / 2;

    console.log('pollPosition',this.pollPosition.x, this.pollPosition.y);
    console.log('poll',this.poll.x, this.poll.y);
    this.$emit('updatePollPosition', this.pollPosition);

  },

  moveSliderHandle(event, init=false) {
    this.sliderMoving = true;
    console.log("moveSlider", event, this.sliderPosition);
    let target = event.target
    let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
    let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

    if (this.slider && this.slider.x && this.slider.y && init) {
      x = this.sliderPosition.x - target.offsetLeft - target.offsetWidth / 2;
      y = this.sliderPosition.y - target.offsetTop - target.offsetHeight / 2;
    }
    // translate the element
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

    // update the posiion attributes
    target.setAttribute('data-x', x)
    target.setAttribute('data-y', y)

    console.log(target.offsetTop, y ,  target.offsetHeight / 2, target);
    this.sliderPosition.x = target.offsetLeft + x + target.offsetWidth / 2;
    this.sliderPosition.y = target.offsetTop + y + target.offsetHeight / 2;

    console.log('sliderPosition',this.sliderPosition.x, this.sliderPosition.y);
    console.log('slider',this.slider.x, this.slider.y);
    this.$emit('updateSliderPosition', this.sliderPosition);

  },


    openHighlight() {
      if (this.highlightPopup === false && this.highlightsPage.length === 0) {
        console.log(this.$refs);
        this.getHighlightsInstagram({id: this.pageInfo.id}).then(res => {
                    console.log(res.body.highlights);
                    this.highlightsPage = res.body.highlights
        });
      }
      this.highlightPopup = true;
    },

    selectHighlight() {
      if (!this.isValidHightlight) return
      this.highlightPopup = false
      console.log(this.currentHighlight);
      this.$emit('sendHighlight', this.currentHighlight === '__new_highlight__' ? this.newHighlight : this.currentHighlight);
    },

    blobUrlToBase64String(url) {
      console.log('blobUrlToBase64', url);
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function(e) {
          if (this.status == 200) {
            const reader = new FileReader();
            reader.onload = function(e) {
              resolve(e.target.result);
            };
            reader.readAsDataURL(this.response);
          } else {
            reject(this.statusText);
          }
        };
        xhr.send();
      });
    },

    async getAverageImageBackground() {
          const image = document.getElementById('main-img')
          if (image) {
            const fac = new FastAverageColor();
            let facColor = await fac.getColorAsync(image)
            console.log('backcolor',facColor);
            this.$emit('newBackground', facColor.value);
          }
    },

    async cropForFormat(isUrl= false) {
      if (!this.image) return
      //if this.image is blob url then convert to base64
      if (this.image.startsWith('blob:')) {
        this.image = await this.blobUrlToBase64String(this.image);
      }
      console.log('crop', this.image);
      this.$emit('cropImage', this.image, isUrl);
      // if (this.autoCrop) {
        // this.$vs.loading({container: this.$refs.screen, color: '#43153D'});
      if (!isUrl) {
        this.imageNoUrl = true
      }
      // const observer = new MutationObserver(async (mutations, me) => {
      this.$nextTick(async () => {
          this.transformImage();

          const image = document.getElementById('main-img')
          console.log('ldffdf', image);
          if (image && !this.template && !this.onlyViewMode && !this.injectedBackground) {
            // image.onload = async () => {
              const fac = new FastAverageColor();
              let facColor = await fac.getColorAsync(image)
              // this.imageAverageColor = facColor.hex;
              console.log('backcolor',facColor);
              this.$emit('newBackground', facColor.value);
              // me.disconnect();
            // }
          }
          
        //       // console.log(image);
        //       this.cropper = new Cropper(image, {
        //         aspectRatio: this.screenWidth/this.screenHeight, dragMode: 'move', checkCrossOrigin: true, checkOrientation: false, cropBoxMovable: false, cropBoxResizable: false, zoomOnWheel: false, guides: false,
        //         ready: () => {
        //           this.cropper.setCropBoxData({width: this.screenWidth, height: this.screenHeight, left: 0, top: 0});
        //           this.cropper.scale(1, 1)
        //           this.cropZoom = (this.cropper.getCanvasData().width / this.cropper.getCanvasData().naturalWidth).toFixed(2);
        //           // setTimeout(() => this.confirmCrop(), 50)
        //           this.confirmCrop();
        //         }
        //       })
        //     }
        //   }
        });
        // observer.observe(this.$refs.screen, {
        //   childList: true,
        //   subtree: true
        // });
        // setTimeout( async () => {
          // const image = document.getElementById('main-img')
          
          
        // }, 1)
      // }
    },

    // captureActualAsPicture() {
    //   if (this.gifs && this.gifs.length > 0) {
    //     for (let i = 0; i < this.gifs.length; i++){
    //       document.getElementById(`gif-${i}-${this.onlyViewMode}`).style.border = 'none';
    //     }
    //   }
    //   let screen = this.$refs['screen']
    //   for (let k = 0 ; k <  this.text.length; k++) {
    //     let txt = this.$refs[`text${k}`]
    //     if (txt && txt[0] && txt[0].style) {
    //       txt[0].style.border = 'none';
    //     }
    //   }
    //   console.log(screen.style);
    //   screen.style.borderColor = 'transparent';
    //   screen.style.border = 'none';
    //   console.log(screen.style);
    //   return new Promise((resolve, reject) => {
    //     // if (!this.text[this.currentTextIndex].background || this.text[this.currentTextIndex].background === 0) resolve(null);
    //     return html2canvas(screen, {allowTaint: true, useCORS:true, backgroundColor: this.imageAverageColor, scale: 2}).then(canvas => {
    //       // screen.parentNode.appendChild(canvas);
    //       // this.deleteText()
    //       // return
    //       let image = canvas.toDataURL('image/png')
    //       screen.style.border = 'black 5px solid';
    //       screen.style.borderColor = 'black';
    //       resolve(image)
    //     });
    //   })
        
    // },

    textFont(fontIdx) {
      this.text[this.currentTextIndex].font = fontIdx
      this.$nextTick(() => {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        this.setEndOfContenteditable(this.textElement())
      })
    },

    justifyText() {
      // console.log(this.justify);
      let txtEl = this.textElement()
      // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
      switch(this.justify) {
        case "center":
          this.justify = "left"
          this.text[this.currentTextIndex].x = 20
          this.text[this.currentTextIndex].y = (this.screenHeight / 2) - (txtEl.offsetHeight / 2)
          break
        case "left":
          this.justify = "right"
          this.text[this.currentTextIndex].x = this.screenWidth - txtEl.offsetWidth - 10 - 20
          this.text[this.currentTextIndex].y = (this.screenHeight / 2) - (txtEl.offsetHeight / 2)
          break
        case "right":
          this.justify = "center"
          this.text[this.currentTextIndex].x = (this.screenWidth / 2) - (txtEl.offsetWidth / 2) - 5
          this.text[this.currentTextIndex].y = (this.screenHeight / 2) - (txtEl.offsetHeight / 2)
          break
      }
      this.setEndOfContenteditable(txtEl)
    },

    cancelCrop() {
      this.cropMode = false
      this.cropZoom = (this.cropper.getCanvasData().width / this.cropper.getCanvasData().naturalWidth).toFixed(2)
      this.cropper.destroy()
      this.cropper = null
    },

    changeZoom() {
      if (this.cropper) {
        // let zoom = this.cropZoom - this.oldCropZoom
        this.cropper.zoomTo(this.cropZoom, {
          x: this.cropper.getContainerData().width / 2,
          y: this.cropper.getContainerData().height / 2
        })
        // this.cropper.zoom(value)
        // console.log('width', this.cropper.getCanvasData().width)
        // console.log('natwidth', this.cropper.getCanvasData().naturalWidth)

        // this.oldCropZoom = this.cropZoom
      }
    },

    confirmCrop() {
      let canvas
      canvas = this.cropper.getCroppedCanvas()
      this.$vs.loading.close(this.$refs.screen);
      console.log(canvas);
      // console.log(canvas)
      if (canvas) {
        this.image = canvas.toDataURL('image/png')
        this.cancelCrop()
        this.$emit('cropImage', this.image);
      }
    },

    cropImage() {
      // const image = document.getElementById('main-img')
      const image = document.getElementById('main-img')
      if (!image) return
      this.cropMode = true
      console.log('crop', image)
      this.cropper = new Cropper(image, {
        aspectRatio: this.screenWidth/this.screenHeight,
        // viewMode: 1,
        dragMode: 'move',
        checkCrossOrigin: true,
        checkOrientation: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        zoomOnWheel: false,
      })

      image.addEventListener('cropmove', (event) => {
        let dataCropper = this.cropper.getData();
        let dataCropperImage = this.cropper.getImageData();
        let ratio = dataCropperImage.width / dataCropperImage.naturalWidth
        let posiX = ((dataCropper.x * -1 * ratio) + (dataCropperImage.width/2));
        let posiY = ((dataCropper.y * -1 * ratio) + (dataCropperImage.height/2));
        let shift = 3;
        if ((Math.floor(posiX) > (Math.floor(this.screenWidth/2) - shift)) && (Math.floor(posiX) < (Math.floor(this.screenWidth/2) + shift))) {
          this.centerWidget = true;
        } else {
          this.centerWidget = false;
        }
      });

      image.addEventListener('cropend', (event) => {
          this.centerWidget = false;
      });

      
      setTimeout(() => {
        this.cropper.setCropBoxData({
          width: this.screenWidth,
          height: this.screenHeight,
          left: 0,
          top: 0
        });
        this.cropper.scale(1, 1)
        this.cropZoom = (this.cropper.getCanvasData().width / this.cropper.getCanvasData().naturalWidth).toFixed(2);
      }, 50)
    },


    textExpandSize(e) {
      // console.log('tefffxt', this.$refs['text'])
      // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
      let w = this.textElement().offsetWidth
      // console.log('SIZE', w, this.text[this.currentTextIndex].x, this.oldWidthText[this.currentTextIndex])
      if (this.oldWidthText.length > 0) {
        this.text[this.currentTextIndex].x =
          parseInt(this.text[this.currentTextIndex].x) + parseInt((this.oldWidthText[this.currentTextIndex] - w) / 2)
      } 
      // console.log('SIZE2', this.text[this.currentTextIndex].x)
      this.oldWidthText[this.currentTextIndex] = w
    },


    getMeta(url, trynb=0) {
      if (this.video && this.isVideo) return
      if (url.startsWith("https://www.instagram.com")) {
        this.notify({
            title:'Mauvais champ',
            text:this.$t('dash.notify.field_storification'),
            color:'warning',
            time: 10000,
            id: 'norepeat'
          })
        return
      }
      // eslint-disable-next-line no-useless-escape
      if (url && /^(http|https)?:\/\/([\w\d\-]+\.)+\w{2,}(\/.+)?$/.test(url)) {
        this.$vs.loading({container: this.$refs.screen, color: '#43153D'})
        this.getNewsMeta(url).then((res) => {
          const { success, meta } = res.body
          if (!success || success !== true) {
            this.$vs.loading.close(this.$refs.screen);
            if (trynb < 3) {
              this.getMeta(url, ++trynb);
              console.log('retry');
            }
            // this.dialog.title = 'Error'
            // if (!res.body) {
            //   this.dialog.message = 'Server not responding…'
            // } else {
            //   this.dialog.message = res.body.statusText
            // }
            // this.dialog.show = true
            return
          }
          console.log(meta.og.image);
          this.getImageFromUrl(meta.og.image).then((result) => {
             this.$vs.loading.close(this.$refs.screen)
            console.log(result.body.image)
            this.image = result.body.image
            this.cropForFormat(true);
              // setTimeout(() => {
              //   const image = document.getElementById('main-img')
              //   const fac = new FastAverageColor();
              //   let facColor = fac.getColor(image)
              //   this.imageAverageColor = facColor.hex;
              //   console.log(facColor);
              //   this.$emit('newBackground', facColor.value)
              //   console.log(image);
              //   this.cropper = new Cropper(image, {
              //     aspectRatio: this.screenWidth/this.screenHeight,dragMode: 'move', checkCrossOrigin: true, checkOrientation: false, cropBoxMovable: false, cropBoxResizable: false, zoomOnWheel: false, guides: false
              //   })
              
              //   setTimeout(() => {
              //     this.cropper.setCropBoxData({width: this.screenWidth, height: this.screenHeight, left: 0, top: 0});
              //     this.cropper.scale(1, 1)
              //     this.cropZoom = (this.cropper.getCanvasData().width / this.cropper.getCanvasData().naturalWidth).toFixed(2);
              //     this.confirmCrop();
              //   }, 50)
              // }, 50)
            
          })
        })
      }
    },

    submitTemplate() {
      console.log('SUBMIT !')
    },

    deleteText() {
      this.text.splice(this.currentTextIndex, 1);
      this.oldWidthText.splice(this.currentTextIndex, 1);
      this.currentTextIndex = 0
      this.dragText = false
      this.textMode = false
      if (this.text.length === 0) {
        this.text.push({
          x: this.screenWidth / 2 - 15,
          y: this.screenHeight / 2 - 50,
          content: '',
          color: 'white',
          // color: 'red',
          size: 22,
          font:  1,
          background:  0,
          angle:  0
        })
        this.oldWidthText.push(30);
        this.currentTextIndex = this.text.length - 1;
      }
    },

    addImage() {
      document.getElementById('input-image').click()
    },

    chooseImage(event) {
      this.autoCrop = true;
      console.log(event.target.files)
      let fileReader = new FileReader()
      fileReader.onload = () => {
        this.image = fileReader.result
        this.cropForFormat();
        //   console.log("ii");
        // if (this.autoCrop) {
        //   console.log("AUTOCROP");
        //   this.imageNoUrl = true
        //   setTimeout(() => {
        //     const image = document.getElementById('main-img')
        //     const fac = new FastAverageColor();
        //     let facColor = fac.getColor(image)
        //     this.imageAverageColor = facColor.hex;
        //     console.log(facColor);
        //     this.$emit('newBackground', facColor.value)
        //     this.cropper = new Cropper(image, {
        //       aspectRatio: this.screenWidth/this.screenHeight, dragMode: 'move', checkCrossOrigin: true, checkOrientation: false, cropBoxMovable: false, cropBoxResizable: false, zoomOnWheel: false, guides: false
        //     })
        //     setTimeout(() => {
        //       this.cropper.setCropBoxData({width: this.screenWidth, height: this.screenHeight, left: 0, top: 0});
        //       this.cropper.scale(1, 1)
        //       this.cropZoom = (this.cropper.getCanvasData().width / this.cropper.getCanvasData().naturalWidth).toFixed(2);
        //       this.confirmCrop();
        //     }, 50)
        //   }, 50)
        // }
      }
      fileReader.readAsDataURL(event.target.files[0])
    },

    removeOnlyImage() {
      this.image = null
      this.imageNoUrl = false;
      if (this.link) {
        this.getMeta(this.link)
      }
    },

    resetStory() {
      console.log('delete')
      this.image = null
      this.imageNoUrl = false;
      this.confirmDelete = false
      this.text = [{
        x: this.screenWidth / 2 - 15,
        y: this.screenHeight / 2 - 50,
        content: '',
        color: 'white',
        // color: 'red',
        size: 22,
        font:  1,
        background:  0,
        angle:  0
      }]
      this.oldWidthText = [30];
      this.currentTextIndex = this.text.length - 1;
      // this.manualLayers = [];
      this.$emit('cancelStory')
    },

    addText() {
      console.log('add text',this.text)
      let emptyTextIndex = this.text.findIndex(e => e.content === '');
      if (this.music) {
        this.$emit("toggleMusicConfig", false);
      }
      if (emptyTextIndex === -1) {

        this.text.push({
          x: this.screenWidth / 2 - 15,
          y: this.screenHeight / 2 - 50,
          content: '',
          color: 'white',
          // color: 'red',
          size: 22,
          font:  1,
          background:  0,
          angle:  0

        })
        this.oldWidthText.push(30);
        this.currentTextIndex = this.text.length - 1;
        this.textMode = true
      } else {
        this.currentTextIndex = emptyTextIndex;
        this.textMode = true
      }

      setTimeout(() => {
        // console.log(this.$refs['text']);
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        // console.log(this.$refs, this.text);
        this.setEndOfContenteditable(this.textElement())
      }, 50)
      // this.$nextTick(() => {
      //   // console.log(this.$refs['text']);
      //   // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
      //   // console.log(this.$refs, this.text);
      //   this.setEndOfContenteditable(this.textElement)
      // })
    },

    nextTickSetEndOfContenteditable() {
      this.$nextTick(() => {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        this.setEndOfContenteditable(this.textElement())
      })
    },

    setEndOfContenteditable(contentEditableElement) {
      contentEditableElement.focus()
      let range, selection
      if (document.createRange) {
        //Firefox, Chrome, Opera, Safari, IE 9+
        range = document.createRange() //Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(contentEditableElement) //Select the entire contents of the element with the range
        range.collapse(false) //collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection() //get the selection object (allows you to change selection)
        selection.removeAllRanges() //remove any selections already made
        selection.addRange(range) //make the range you have just created the visible selection
      } else if (document.selection) {
        //IE 8 and lower
        range = document.body.createTextRange() //Create a range (a range is a like the selection but invisible)
        range.moveToElementText(contentEditableElement) //Select the entire contents of the element with the range
        range.collapse(false) //collapse the range to the end point. false means collapse to end rather than the start
        range.select() //Select the range (make it the visible selection
      }
    },

    modifyText(idx) {
      if (this.textMode || !this.clickPossible || this.onlyViewMode) return
      this.currentTextIndex = idx;
      // console.log('modify')
      this.textMode = true
      if (this.music) {
        this.$emit("toggleMusicConfig", false);
      }
      this.$nextTick(() => {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        this.setEndOfContenteditable(this.textElement())
      })
    },

    confirmText() {
      // this.text[this.currentTextIndex].content = this.$refs.text.innerText
      this.textMode = false
    },

    moveText(e) {
      if (this.dragText) {
        if (this.textStatic) {
          this.textStatic = false;
        }
        this.moveWidget(e, true);
        this.clickPossible = false
        let screenPosition = document
          .getElementsByClassName('screen-instagram')[0]
          .getBoundingClientRect()
        // if (
        //   e.clientX - e.target.offsetWidth / 2 <= screenPosition.x ||
        //   e.clientY - e.target.offsetHeight / 2 <= screenPosition.y + 5 ||
        //   e.clientX + e.target.offsetWidth / 2 >=
        //     screenPosition.x + screenPosition.width - 5 ||
        //   e.clientY + e.target.offsetHeight / 2 >=
        //     screenPosition.y + screenPosition.height - 5
        // )
          // return
        // console.log('x::::',e.clientX - screenPosition.x + this.dragText.target.offsetWidth / 2, screenPosition.width)
        const x = Math.max(Math.min(e.clientX - screenPosition.x - this.dragText.target.offsetWidth / 2, this.screenWidth - this.dragText.target.offsetWidth), 1);
        if (this.dragText.target.parentElement.offsetWidth + x >= screenPosition.width - 10) {
          console.log("TOUCH",screenPosition.width -  this.dragText.target.parentElement.offsetWidth - 10);
          this.text[this.currentTextIndex].x = screenPosition.width - this.dragText.target.parentElement.offsetWidth - 11;
        } else {
          this.text[this.currentTextIndex].x = x
        }

        // this.text[this.currentTextIndex].x = 
        //   Math.max(Math.min(e.clientX - screenPosition.x - this.dragText.target.offsetWidth / 2, this.screenWidth - this.dragText.target.offsetWidth), 1)
        
        this.text[this.currentTextIndex].y = 
          Math.max(Math.min(e.clientY - screenPosition.y - this.dragText.target.offsetHeight / 2, this.screenHeight - this.dragText.target.offsetHeight), this.screenHeight * 0.01)

      } else if (this.rotateText) {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        let rect = this.textElement().getBoundingClientRect()
        let middle_x = rect.left + (rect.width / 2)
        let middle_y = rect.top + (rect.height / 2)
        let x = e.clientX - middle_x
        let y = e.clientY - middle_y
        let angle = Math.atan2(y, x) + (Math.PI / 2)
        this.text[this.currentTextIndex].angle = angle * 180 / Math.PI % 360;
      }
    },

    rotateTextBegin(e, idx) {
      if (!this.text || this.onlyViewMode) return
      this.currentTextIndex = idx;
      this.rotateText = e
    },

    moveTextBegin(e, idx) {
      if (!this.text || this.onlyViewMode) return
      this.currentTextIndex = idx;
      // console.log(idx);
      // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
      // console.log('ON', this.currentTextIndex, e)
      this.dragText = e
      // this.textElement.style.width =
      //   this.textElement.offsetWidth + 10 + 'px'
      // console.log(this.textElement().offsetWidth)
    },

    moveTextEnd(e) {
      this.centerWidget = false;
      if (!this.text) return
      console.log('OFF', this.linkPosition)
      this.dragText = null
      this.rotateText = null
      // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
      // this.textElement.style.width = 'auto'
      setTimeout(() => {
        this.clickPossible = true;
        this.linkMoving = false;
        this.sliderMoving = false;
        this.pollMoving = false;
        this.mentionsWidgetMoving = false;
      }, 500)
    },

    changeSize() {
      this.$nextTick(() => {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        this.setEndOfContenteditable(this.textElement())
      })
    },

    changeColor(color) {
      this.text[this.currentTextIndex].color = color
      this.$nextTick(() => {
        // let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
        this.setEndOfContenteditable(this.textElement())
      })
    },



    centerText(idx) {
      let txtEl = this.textElement(idx)
      // console.log(txtEl);
      // console.log("w/h:",txtEl.offsetWidth, txtEl.offsetHeight, this.text[idx].x);
      // console.log(parseFloat(this.text[idx].x + txtEl.offsetWidth / 2), parseFloat(parseFloat(this.text[idx].y) + txtEl.offsetHeight / 2));
      return {x: parseFloat(this.text[idx].x) + txtEl.offsetWidth / 2, y: parseFloat(this.text[idx].y) + txtEl.offsetHeight / 2}
    },

    // centerDefault() {
    //   if (this.text.angle % 360 === 0) {
    //     let txtEl = this.$refs['text'].$el ? this.$refs['text'].$el : this.$refs['text'];
    //     this.centerText = {x: parseFloat(this.text.x + this.textElement.getBoundingClientRect().width / 2), y: parseFloat(this.text.y + this.textElement.getBoundingClientRect().height / 2)}
    //     return this.centerText
    //   } else {
        
    //   }
    // },

    rotatedPosition(idx){
      // console.log(this.text[idx].x, this.text[idx].y);
      let angle = this.text[idx].angle * Math.PI / 180 * -1;
      let xM = this.text[idx].x - this.centerText(idx).x;
      let yM = this.text[idx].y - this.centerText(idx).y;
      let x = xM * Math.cos(angle) + yM * Math.sin(angle) + this.centerText(idx).x;
      let y = - xM * Math.sin(angle) + yM * Math.cos(angle) + this.centerText(idx).y;
      return ({x:Math.round(x), y:Math.round(y)});

      // console.log(this.textElement);
      // let originX = parseFloat(this.text.x + this.textElement.offsetWidth / 2)
      // let originY = parseFloat(this.text.y + this.textElement.offsetHeight / 2)
      // console.log(originX, originY);
      // // 1
      // let x = this.text.x - originX;
      // let y = this.text.y - originY;
      // console.log(x, y);


      // // 2
      // // let angle = this.text.angle * 180 / Math.PI;
      // console.log('angle', this.text.angle, this.text.angle);
      // let xRot = x * Math.cos(this.text.angle) - y * Math.sin(this.text.angle);
      // let yRot = x * Math.sin(this.text.angle) + y * Math.cos(this.text.angle);
      // console.log(xRot, yRot);

      // // 3
      // let pLeftRot = xRot + parseFloat(originX);
      // let pTopRot = yRot + parseFloat(originY)
      // return {x: this.text.x, y:  this.text.y};
    },

    textElement(idx) {
      if (!idx) idx = this.currentTextIndex
      if (!this.$refs[`text${idx}`] || this.$refs[`text${idx}`].length === 0) return {offsetWidth: 30, offsetHeight: 30};
      // console.log('elem',this.$refs, idx, this.$refs[`text${idx}`].$el);
      return this.$refs[`text${idx}`][0].$el ? this.$refs[`text${idx}`][0].$el : this.$refs[`text${idx}`][0];
    },

    showEditPost(field){      
      for(let indexField in this.activeEdit) {
        //save any changes
        if(this.activeEdit[indexField])
          this.$emit('editPostLive', this.pageInfo.id, indexField, this.editValue[indexField])
        //close all edit fields
        this.activeEdit[indexField] = false
      }
      //event to save&close changes on others previews
      this.$emit('currentPostLive', this.pageInfo.id, field)

      this.activeEdit[field] = true

      if(field == 'scheduling') {
        if(moment(this.editValue.scheduling.date).isBefore(moment().add(12, 'minutes'))) {
          this.$set(this.editValue, 'scheduling', {
            date: moment().add(12, 'minutes').utc().local().format(),
            time: {
              HH: moment().add(12, 'minutes').utc().local().hour() < 10 
                                                  ? `0${moment().add(12, 'minutes').utc().local().hour()}`
                                                  : `${moment().add(12, 'minutes').utc().local().hour()}`,
              mm: moment().add(12, 'minutes').utc().local().minute() < 10 
                                                  ?`0${moment().add(12, 'minutes').utc().local().minute()}`
                                                  : `${moment().add(12, 'minutes').utc().local().minute()}`
            }
          })
        }
      }

      if(!this.editValue[field] && field !== 'scheduling')
          this.editValue[field] = this.post[field]          
            
      let indexEdit = this.editPostValue.findIndex(p => p.page == this.pageInfo.id)
      if(field === 'title') {
        if(indexEdit >= 0 && this.editPostValue[indexEdit].title)
          this.$set(this.editValue, field, this.editPostValue[indexEdit].title)
        this.$nextTick(() => {
          this.textAreaAdjust(`inputTitle-${this.pageInfo.network_id}`)
        })
      }
    },

    textAreaAdjust(element) {
      document.getElementById(element).style.height = "1px";
      document.getElementById(element).style.height = (25+document.getElementById(element).scrollHeight)+"px";
    },

    addHashtagsLinks(str) {
      if(str){
        str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.instagram.com/explore/tags/${match.replace('#', '')}" target="_blank">${match}</a>`});
        //email links
        str = str.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/ig, "<a href='mailto:$1' target='_blank'>$1</a>");
        //retour à la ligne
        str = str.replace(/(?:\r\n|\r|\n)/g, '<br />')
      }
      return str
    },

    getMessageToPost(post){
      let indexEdit = this.editPostValue.findIndex(p => p.page == this.pageInfo.id)
      if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit].title)
        return this.transformMentionAndHashtag(this.editPostValue[indexEdit].title);
      
      return this.transformMentionAndHashtag(post.title);

    },

    styleSelection(type) {
      let a = this.$refs[`inputTitle-${this.pageInfo.network_id}`].$el.firstElementChild;
      let start = a.selectionStart;
      let end = a.selectionEnd;
      let styled = '';
      if (start !== end && !Fonts.checkIfMention(this.editValue.title, start, end)) {
        switch (type) {
          case 'bold': styled = Fonts.bold(this.editValue.title.substring(start, end));
          break;
          case 'italic': styled = Fonts.italic(this.editValue.title.substring(start, end));
          break;
          case 'underline': styled = Fonts.underline(this.editValue.title.substring(start, end));
          break;
          default: styled = this.editValue.title.substring(start, end);
        }
        this.editValue.title = this.editValue.title.substring(0, start) + styled + this.editValue.title.substring(end);
      }
      a.focus();
      this.$nextTick(() => {
        a.setSelectionRange(start, start+styled.length);
      });
    },

    toggleShowMentions(type='Mention', idx=null) {    
        let a = this.$refs[`inputTitle-${this.pageInfo.network_id}`].$el.firstElementChild;
        let start = a.selectionStart;
        let end = a.selectionEnd;
        let message = this.editValue.title

        let previewEdited = { page: this.pageInfo }
        previewEdited[type.toLowerCase()] = {
          add: true,
          start: message.substr(0, start - 1),
          end: message.substr(end), // + 1),
          selected: start != end ? message.substr(start, end-start) : ''
        }

        this.$emit('addMention', type, idx, previewEdited)
        this.editPost('title')
    },

    async getAccrochesByAI() {
      let search = this.post.title
      if(!this.post.title.length && this.post.url.length && this.meta) {
        search = this.meta.og && this.meta.og.title ? this.meta.og.title : this.meta.meta.title
        search += `\n${this.meta.og && this.meta.og.description ? this.meta.og.description : this.meta.meta.description}`
      }

      if(search.length) {
        this.showLoader = true

        this.generateTextByAI(search, this.pageInfo.network).then(res => {
          
          this.showLoader = false

          if(res && res.body && res.body.success){
            this.accrochesAI = res.body.accoches
            this.openAccrochesAI = true
          }
          else
            this.notify({
              title:'Erreur',
              text:JSON.stringify(res.body),
              color:'success',
              time: 10000,
              id: this.pageInfo.id
            })
        })
      }
    },

    limitText(){
      let limitText = null
      if(this.editValue.title) {
        limitText = 2200
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      return limitText
    },

    sizeCurrentMessage() {
      let message = this.activeEdit.title ? this.editValue.title : this.getMessageToPost(this.post)
      return message.length
    },

    styledText() {
      if ((!this.$refs[`inputTitle-${this.pageInfo.network_id}`] || !this.$refs[`inputTitle-${this.pageInfo.network_id}`].$el)) return '';
      let b = null;
      let a = this.$refs[`inputTitle-${this.pageInfo.network_id}`].$el.firstElementChild;
      if (a.selectionStart !== a.selectionEnd) {
        b = this.editValue.title.substring(a.selectionStart, a.selectionEnd);
      } else {
        if (!this.editValue.title.slice(a.selectionStart)) return '';
        if(this.editValue.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu))
          b = this.editValue.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu)[0];
      }
      return Fonts.styledText(b);
    },

    editPost(field, storification){
      this.$emit('editPostLive', this.pageInfo.id, field, this.editValue[storification ? "storification" : field], storification)
      this.activeEdit[field] = false
    },

    hideEmojiPicker() {
      this.showEmojiPicker = false
    },

    addEmoji (emoji, idx) {
      const textarea = document.getElementById(`inputTitle-${this.pageInfo.network_id}`)
      const cursorPosition = this.getInputSelection(textarea);
      const start = this.editValue.title.substring(0, cursorPosition.start)
      const end = this.editValue.title.substring(cursorPosition.end)
      
      this.editValue.title = start + emoji.native + end
      
      textarea.focus()
      this.hideEmojiPicker()
    },
    toggleEmojiPicker (e) {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    getInputSelection(el) {
      let start = 0, end = 0, normalizedValue, range,
          textInputRange, len, endRange;
      if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
          start = el.selectionStart;
          end = el.selectionEnd;
      } else {
          range = document.selection.createRange();
          if (range && range.parentElement() == el) {
              len = el.value.length;
              normalizedValue = el.value.replace(/\r\n/g, "\n");
              textInputRange = el.createTextRange();
              textInputRange.moveToBookmark(range.getBookmark());
              endRange = el.createTextRange();
              endRange.collapse(false);

              if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                  start = end = len;
              } else {
                  start = -textInputRange.moveStart("character", -len);
                  start += normalizedValue.slice(0, start).split("\n").length - 1;

                  if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                      end = len;
                  } else {
                      end = -textInputRange.moveEnd("character", -len);
                      end += normalizedValue.slice(0, end).split("\n").length - 1;
                  }
              }
          }
      }
      return {
          start: start,
          end: end
      };
    },
  }
}
</script>

<style scoped>

.styles-text-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 40%;
  flex-direction: row;
}

.styles-text-buttons > span {
  position: static;
  width: 30px;
  margin-right: 3px;
}

.textarea-emoji-picker {
  position: relative;
  margin: 0 auto;
  clear: both;
}
.textarea {
  width: 100%;
  min-height: 300px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #BABABA;
  color: #333;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
  resize: vertical;
}
.emoji-mart {
  position: absolute;
  top: 0px;
  right: calc(-100% + 45px);
  z-index: 8;
  right: 0;
}
.emoji-trigger {
  position: absolute;
  bottom: 10px;
  right: 20px;
  cursor: pointer;
  height: 20px;
  z-index: 1;
}
.emoji-trigger path {
  transition: 0.1s all;
}
.emoji-trigger {
  background: #fff;
  border-radius: 7px;
  width: 33px;
  height: 33px;
  padding: 6px 5px;
}
.emoji-trigger:hover,
.emoji-trigger.triggered {
  background: #6a1f4c;
}
.emoji-trigger path {
  fill: #6a1f4c;
}
.emoji-trigger:hover path,
.emoji-trigger.triggered path {
  fill: #fff;
}
</style>